import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import { pdfHeader, pdfFooter, pdfTableStyles } from "../../../../pdfUtils";
import axios from "axios";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from "moment";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { v4 as uuidv4 } from "uuid";
import * as XLSX from "xlsx";
import { MapContainer, TileLayer, Marker, Polyline } from 'react-leaflet';
import L from 'leaflet';
// import { set } from "mongoose";
import ContenedorRastreo from "./ContenedorRastreo";
import CamposEmbarque, { PuertoSelect, RevalidadorSelect } from "./CamposEmbarque";
import { usePuertos, guardaConAvisos, muestraFecha, sinFecha, ETAPAS_VIAJE } from "./contenedorUtils";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

// Color del badge de "Status" de seguimiento (solo presentación)
const badgeStatusSeguimiento = (status) => {
  const s = String(status || "").toLowerCase();
  if (["entregado", "despachado", "documentos completos", "desaduanado", "pedimento pagado", "revalidado", "retorno vacio"].includes(s)) return "success";
  if (["cancelado", "accidentado", "robado", "abandono", "pama", "bloqueado por revision de aduana", "retenido desde llegada", "naviera freno demoras"].includes(s)) return "danger";
  if (["pendiente", "por definir"].includes(s)) return "warning";
  return "info";
};

function ListadoContenedores() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_CONTENEDORES = process.env.REACT_APP_URL_CONTENEDORES;
  const URL_ARTICULOS_CONTENEDOR = process.env.REACT_APP_URL_ARTICULOS_CONTENEDOR;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_BROKERS = process.env.REACT_APP_URL_BROKERS;
  const URL_FORWARDERS = process.env.REACT_APP_URL_FORWARDERS;
  const URL_NAVIERAS = process.env.REACT_APP_URL_NAVIERAS;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_UPMEDIA = process.env.REACT_APP_URL_UPMEDIA;
  const URL_UPMEDIA_PACKING = process.env.REACT_APP_URL_UPMEDIA_PACKING;
  const URL_UPMEDIA_BL = process.env.REACT_APP_URL_UPMEDIA_BL;
  const URL_UPMEDIA_INVOICE = process.env.REACT_APP_URL_UPMEDIA_INVOICE;
  const URL_UPMEDIA_FICHA_TECNICA = process.env.REACT_APP_URL_UPMEDIA_FICHA_TECNICA;
  const URL_UPMEDIA_CARGOS_LOCALES = process.env.REACT_APP_URL_UPMEDIA_CARGOS_LOCALES;
  const URL_UPMEDIA_DODA = process.env.REACT_APP_URL_UPMEDIA_DODA;
  const URL_UPMEDIA_BOLETA = process.env.REACT_APP_URL_UPMEDIA_BOLETA;
  const URL_UPMEDIA_PREALTA = process.env.REACT_APP_URL_UPMEDIA_PREALTA;
  const URL_UPMEDIA_EIR = process.env.REACT_APP_URL_UPMEDIA_EIR;
  const URL_UPMEDIA_BLREVALIDADO = process.env.REACT_APP_URL_UPMEDIA_BLREVALIDADO;
  const URL_UPMEDIA_DEMORAS_CARTAS = process.env.REACT_APP_URL_UPMEDIA_DEMORAS_CARTAS;
  const URL_UPMEDIA_VALIDACION = process.env.REACT_APP_URL_UPMEDIA_VALIDACION;
  const URL_UPMEDIA_GARANTIA = process.env.REACT_APP_URL_UPMEDIA_GARANTIA;
  const URL_UPMEDIA_TRANSPORTE = process.env.REACT_APP_URL_UPMEDIA_TRANSPORTE;
  const URL_DELMEDIA = process.env.REACT_APP_URL_DELMEDIA;
  const URL_FILEPOST = process.env.REACT_APP_URL_UPPROFILE;
  const [t, i18n] = useTranslation("global");
  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 91);

  let comp30 = new Date();
  comp30.setDate(comp30.getDate() - 30);

  let fechaEditArticulos = moment(hoy).format("YYYY-MM-DD");
  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [articulos, setArticulos] = useState([]);

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [brokers, setBrokers] = useState([]);
  const [selectedBroker, setSelectedBroker] = useState("");
  const [forwarders, setForwarders] = useState([]);
  const [selectedForwarder, setSelectedForwarder] = useState("");
  const [navieras, setNavieras] = useState([]);
  const [selectedNaviera, setSelectedNaviera] = useState("");

  const [idClientesEdit, setIdClientesEdit] = useState("");
  const [idBrokersEdit, setIdBrokersEdit] = useState("");
  const [idNavierasEdit, setIdNavierasEdit] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  const [selectedSurtido, setSelectedSurtido] = useState("");
  // const [selectedEnMar, setSelectedEnMar] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [selectedEtapa, setSelectedEtapa] = useState("");
  const [selectedPuertoDestino, setSelectedPuertoDestino] = useState("");
  const [tablaCompacta, setTablaCompacta] = useState(false);
    const [selectedPrioridad, setSelectedPrioridad] = useState("");
  const [selectedPrevio, setSelectedPrevio] = useState("");
  const [selectedPL, setSelectedPL] = useState("");
  const [selectedBL, setSelectedBL] = useState("");
  const [selectedActivo, setSelectedActivo] = useState("");

  const [fecha, setFecha] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [totalGeneral, setTotalGeneral] = useState("");
  const [totalCantidad, setTotalCantidad] = useState("");
  const [numeroContenedor, setNumeroContenedor] = useState("");
  const [rastreo, setRastreo] = useState("No");
  const [surtido, setSurtido] = useState("");
  const [buque, setBuque] = useState("");
  const [puertoDestino, setPuertoDestino] = useState("");
  const [prioridad, setPrioridad] = useState("");

  const [direccionEntrega, setDireccionEntrega] = useState("");
  const [fechaEntrega, setFechaEntrega] = useState("");
  const [horarioEntrega, setHorarioEntrega] = useState("");
  const [contactoEntrega, setContactoEntrega] = useState("");
  const [observacionesEntrega, setObservacionesEntrega] = useState("");

  const [idEdit, setIdEdit] = useState("");
  const [selectedClienteEdit, setSelectedClienteEdit] = useState("");
  const [selectedBrokerEdit, setSelectedBrokerEdit] = useState("");
  const [selectedForwarderEdit, setSelectedForwarderEdit] = useState("");
  const [selectedNavieraEdit, setSelectedNavieraEdit] = useState("");

  const [coordenadasMapa, setCoordenadasMapa] = useState([]);
  const [originCoords, setOriginCoords] = useState([]);
  const [destinationCoords, setDestinationCoords] = useState([]);
  const [vesselCoords, setVesselCoords] = useState([]);
  const [diasLlegada, setDiasLlegada] = useState(0);

  const [modalMapa, setModalMapa] = useState(false);
  const toggleMapa = () => setModalMapa(!modalMapa);

  const [flete, setFlete] = useState("");
  const [incrementable, setIncrementable] = useState("");
  const [liberadoPor, setLiberadoPor] = useState("");
  const [numeroReferencia, setNumeroReferencia] = useState("");
  const [referenciaExtra, setReferenciaExtra] = useState("");
  const [naviera, setNaviera] = useState("");
  const [referencia, setReferencia] = useState("");
  const [fechaETD, setFechaETD] = useState("");
  const [fechaETAEstimada, setFechaETAEstimada] = useState("");
  const [fechaETAReal, setFechaETAReal] = useState("");
  const [fechaLlegada, setFechaLlegada] = useState("");
  const [fechaLiberacion, setFechaLiberacion] = useState("");
  const [fechaEntregaEstimada, setFechaEntregaEstimada] = useState("");
  const [fechaEntregaReal, setFechaEntregaReal] = useState("");
  const [aduana, setAduana] = useState("");

  const [photo, setPhoto] = useState([]);
  const [idContenedor, setIdContenedor] = useState();
  const [file, setFile] = useState([]);
  const [modalFoto, setModalFoto] = useState(false);
  const toggleFoto = () => setModalFoto(!modalFoto);
  const [modalSubirFoto, setModalSubirFoto] = useState(false);
  const toggleSubirFoto = () => setModalSubirFoto(!modalSubirFoto);
  const [modalSubirFotoPacking, setModalSubirFotoPacking] = useState(false);
  const toggleSubirFotoPacking = () => setModalSubirFotoPacking(!modalSubirFotoPacking);
  const [modalFotoPacking, setModalFotoPacking] = useState(false);
  const toggleFotoPacking = () => setModalFotoPacking(!modalFotoPacking);
  const [photoFormat, setPhotoFormat] = useState("");
  const [PLPDF, setPLPDF] = useState("");

  const [modalSubirFotoBL, setModalSubirFotoBL] = useState(false);
  const toggleSubirFotoBL = () => setModalSubirFotoBL(!modalSubirFotoBL);
  const [modalFotoBL, setModalFotoBL] = useState(false);
  const toggleFotoBL = () => setModalFotoBL(!modalFotoBL);

   const [modalSubirFotoValidacion, setModalSubirFotoValidacion] = useState(false);
  const toggleSubirFotoValidacion = () => setModalSubirFotoValidacion(!modalSubirFotoValidacion);
  const [modalFotoValidacion, setModalFotoValidacion] = useState(false);
  const toggleFotoValidacion = () => setModalFotoValidacion(!modalFotoValidacion);

  const [modalSubirFotoInvoice, setModalSubirFotoInvoice] = useState(false);
  const toggleSubirFotoInvoice = () => setModalSubirFotoInvoice(!modalSubirFotoInvoice);
  const [modalFotoInvoice, setModalFotoInvoice] = useState(false);
  const toggleFotoInvoice = () => setModalFotoInvoice(!modalFotoInvoice);

  const [modalSubirFotoFichaTecnica, setModalSubirFotoFichaTecnica] = useState(false);
  const toggleSubirFotoFichaTecnica = () => setModalSubirFotoFichaTecnica(!modalSubirFotoFichaTecnica);
  const [modalFotoFichaTecnica, setModalFotoFichaTecnica] = useState(false);
  const toggleFotoFichaTecnica = () => setModalFotoFichaTecnica(!modalFotoFichaTecnica);

  const [modalSubirFotoCargosLocales, setModalSubirFotoCargosLocales] = useState(false);
  const toggleSubirFotoCargosLocales = () => setModalSubirFotoCargosLocales(!modalSubirFotoCargosLocales);
  const [modalFotoCargosLocales, setModalFotoCargosLocales] = useState(false);
  const toggleFotoCargosLocales = () => setModalFotoCargosLocales(!modalFotoCargosLocales);

  const [modalSubirFotoDODA, setModalSubirFotoDODA] = useState(false);
  const toggleSubirFotoDODA = () => setModalSubirFotoDODA(!modalSubirFotoDODA);
  const [modalFotoDODA, setModalFotoDODA] = useState(false);
  const toggleFotoDODA = () => setModalFotoDODA(!modalFotoDODA);

  const [modalSubirFotoBoleta, setModalSubirFotoBoleta] = useState(false);
  const toggleSubirFotoBoleta = () => setModalSubirFotoBoleta(!modalSubirFotoBoleta);
  const [modalFotoBoleta, setModalFotoBoleta] = useState(false);
  const toggleFotoBoleta = () => setModalFotoBoleta(!modalFotoBoleta);

  const [modalSubirFotoPrealta, setModalSubirFotoPrealta] = useState(false);
  const toggleSubirFotoPrealta = () => setModalSubirFotoPrealta(!modalSubirFotoPrealta);
  const [modalFotoPrealta, setModalFotoPrealta] = useState(false);
  const toggleFotoPrealta = () => setModalFotoPrealta(!modalFotoPrealta);

  const [modalSubirFotoEIR, setModalSubirFotoEIR] = useState(false);
  const toggleSubirFotoEIR = () => setModalSubirFotoEIR(!modalSubirFotoEIR);
  const [modalFotoEIR, setModalFotoEIR] = useState(false);
  const toggleFotoEIR = () => setModalFotoEIR(!modalFotoEIR);

    const [modalSubirFotoBLRevalidado, setModalSubirFotoBLRevalidado] = useState(false);
  const toggleSubirFotoBLRevalidado = () => setModalSubirFotoBLRevalidado(!modalSubirFotoBLRevalidado);
  const [modalFotoBLRevalidado, setModalFotoBLRevalidado] = useState(false);
  const toggleFotoBLRevalidado = () => setModalFotoBLRevalidado(!modalFotoBLRevalidado);

    const [modalSubirFotoDemorasCartas, setModalSubirFotoDemorasCartas] = useState(false);
  const toggleSubirFotoDemorasCartas = () => setModalSubirFotoDemorasCartas(!modalSubirFotoDemorasCartas);
  const [modalFotoDemorasCartas, setModalFotoDemorasCartas] = useState(false);
  const toggleFotoDemorasCartas = () => setModalFotoDemorasCartas(!modalFotoDemorasCartas);

  const [modalSubirFotoGarantia, setModalSubirFotoGarantia] = useState(false);
  const toggleSubirFotoGarantia = () => setModalSubirFotoGarantia(!modalSubirFotoGarantia);
  const [modalFotoGarantia, setModalFotoGarantia] = useState(false);
  const toggleFotoGarantia = () => setModalFotoGarantia(!modalFotoGarantia);

  const [modalSubirFotoTransporte, setModalSubirFotoTransporte] = useState(false);
  const toggleSubirFotoTransporte = () => setModalSubirFotoTransporte(!modalSubirFotoTransporte);
  const [modalFotoTransporte, setModalFotoTransporte] = useState(false);
  const toggleFotoTransporte = () => setModalFotoTransporte(!modalFotoTransporte);

    const [modalFotos, setModalFotos] = useState(false);
  const toggleFotos = () => setModalFotos(!modalFotos);

    const [packing, setPacking] = useState('');
  const [blArchivo, setBlArchivo] = useState('');
  const [validacion, setValidacion] = useState('');
  const [invoice, setInvoice] = useState('');
  const [fichaTecnicaArchivo, setFichaTecnicaArchivo] = useState('');
  const [cargosLocales, setCargosLocales] = useState('');
  const [DODA, setDODA] = useState('');
  const [boleta, setBoleta] = useState('');
  const [prealta, setPrealta] = useState('');
  const [EIR, setEIR] = useState('');
  const [BLRevalidado, setBLRevalidado] = useState('');
  const [demorasCartas, setDemorasCartas] = useState('');
  const [garantia, setGarantia] = useState('');
  const [transporte, setTransporte] = useState('');

  const [fechaEntradaPuerto, setFechaEntradaPuerto] = useState('');
  const [fechaDocumentos, setFechaDocumentos] = useState('');
  const [documentos, setDocumentos] = useState('');
  const [fechaManiobras, setFechaManiobras] = useState('');
  const [maniobras, setManiobras] = useState('');

  const [articulosContenedor, setArticulosContenedor] = useState([]);
  const [modalEditArticulos, setModalEditArticulos] = useState(false);
  const toggleEditArticulos = () => setModalEditArticulos(!modalEditArticulos);
  const [totalGeneral_edit, setTotalGeneralEdit] = useState(0);
  const [totalCantidad_edit, setTotalCantidadEdit] = useState(0);

  const [totalCaptura, setTotalCaptura] = useState(1);

  // const [inputFields, setInputFields] = useState([]);
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      cantidad: 0,
      descripcion: "NA",
      proveedor: "NA",
      marca: "NA",
      PO: 0,
      CBMS: 0,
      precio: 0,
      total: 0,
    },
  ]);

  const [inputFieldsFlete, setInputFieldsFlete] = useState([]);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [modalEditBroker, setModalEditBroker] = useState(false);
  const toggleEditBroker = () => setModalEditBroker(!modalEditBroker);

  const [modalFlete, setModalFlete] = useState(false);
  const toggleFlete = () => setModalFlete(!modalFlete);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);


  // Status
  const [modalStatus, setModalStatus] = useState(false);
  const toggleStatus = () => setModalStatus(!modalStatus);
  const [id, setId] = useState('');
  const [statusSeguimiento, setStatusSeguimiento] = useState('');
  const puertos = usePuertos();
  const [rastreoId, setRastreoId] = useState(null);
  // Datos nuevos del embarque en la edición (tipo, booking, BL, proveedor, referencia del cliente, modalidad, quién paga, puerto de origen)
  const [embarqueEdit, setEmbarqueEdit] = useState({});
  const setEmbEdit = (campo, valor) => setEmbarqueEdit((e) => ({ ...e, [campo]: valor }));
  const [mar, setMar] = useState('');
  const [fechaMar, setFechaMar] = useState('');
  const [observacionesMar, setObservacionesMar] = useState('');
  const [piso, setPiso] = useState('');
  const [fechaPiso, setFechaPiso] = useState('');
  const [observacionesPiso, setObservacionesPiso] = useState('');
  const [revision, setRevision] = useState('');
  const [fechaRevision, setFechaRevision] = useState('');
  const [observacionesRevision, setObservacionesRevision] = useState('');
  const [modulacion, setModulacion] = useState('');
  const [fechaModulacion, setFechaModulacion] = useState('');
  const [observacionesModulacion, setObservacionesModulacion] = useState('');
  const [libre, setLibre] = useState('');
  const [fechaLibre, setFechaLibre] = useState('');
  const [observacionesLibre, setObservacionesLibre] = useState('');

  const [numeroInterno, setNumeroInterno] = useState('');
  const [bl, setBl] = useState('');
  const [fechaBl, setFechaBl] = useState('');
  const [pl, setPl] = useState('');
  const [fechaPl, setFechaPl] = useState('');
  const [facturado, setFacturado] = useState('');
  const [fechaFactura, setFechaFactura] = useState('');
  const [fechaFichaTecnica, setFechaFichaTecnica] = useState('');
  const [telex, setTelex] = useState('');
  const [fechaTelex, setFechaTelex] = useState('');
  const [toquePiso, setToquePiso] = useState('');
  const [fechaToquePiso, setFechaToquePiso] = useState('');
  const [revalidacion, setRevalidacion] = useState('');
  const [fechaRevalidacion, setFechaRevalidacion] = useState('');
  const [pagoPedimento, setPagoPedimento] = useState('');
  const [fechaPagoPedimento, setFechaPagoPedimento] = useState('');
  const [salidaPuerto, setSalidaPuerto] = useState('');
  const [fechaSalidaPuerto, setFechaSalidaPuerto] = useState('');
  const [salidaRuta, setSalidaRuta] = useState('');
  const [fechaSalidaRuta, setFechaSalidaRuta] = useState('');
  const [entregaCliente, setEntregaCliente] = useState('');
  const [fechaEntregaCliente, setFechaEntregaCliente] = useState('');
  const [retornoVacio, setRetornoVacio] = useState('');
  const [fechaRetornoVacio, setFechaRetornoVacio] = useState('');


  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;
  useMemo(() => {
    if (user.tipo == "Forwarder") {
      setSelectedForwarder(user.forwarders);
    }

    if (user.tipo == "Broker") {
      setSelectedBroker(user.brokers);
    }

    if (user.tipo == "Cliente") {
      setSelectedCliente(user.clientes);
    }

    axios
      .get(
        `${URL_CONTENEDORES}Fechas/${selectedFechaInicio}/${selectedFechaFin}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then((response) => {
        let allContenedores = response.data;
        // Array para pagination
        let arrayTabla = allContenedores
          .sort((a, b) => (a.idContenedor < b.idContenedor ? 1 : -1))
          .map((a) => {
return {
  _id: a._id,
  numero: a.idContenedor,
  activo: a.is_active,
  fecha: a.fecha,
  observaciones: a.observaciones,
  totalGeneral: a.totalGeneral,
  naviera: a.navieras[0].name,
  idNaviera: a.navieras[0]._id,
  clientes: a.clientes[0].nombre_comercial,
  idClientes: a.clientes[0]._id,
  brokers: a.brokers[0].name,
  idBrokers: a.brokers[0]._id,
  forwarders: a.forwarders[0].name,
  idForwarders: a.forwarders[0]._id,
  totalCantidad: a.totalCantidad,
  totalSurtido: a.totalSurtido,
  pendienteSurtir: a.pendienteSurtir,
  numeroReferencia: a.numeroReferencia,
  referenciaExtra: a.referenciaExtra,
  referencia: a.referencia,
  etd: a.etd,
  etaEstimada: a.etaEstimada,
  etaReal: a.etaReal,
  pl: a.pl,
  totalGastos: a.totalGastos,
  fechaLlegada: a.fechaLlegada,
  fechaLiberacion: a.fechaLiberacion,
  fechaEntregaEstimada: a.fechaEntregaEstimada,
  fechaEntregaReal: a.fechaEntregaReal,
  aduana: a.aduana,
  surtido: a.surtido,
  previo: a.previo,
  packing: a.packing,
  bl: a.bl,
  blNumero: a.blNumero,
  flete: a.flete,
  incrementable: a.incrementable,
  liberadoPor: a.liberadoPor,
  buque: a.buque,
  puerto: a.puerto,
  puertoDestino: a.puertoDestino,
  prioridad: a.prioridad,

  facturado: a.facturado,
  factura: a.facturado,
  fechaPagoGasto: a.fechaPagoGasto,
  cantidadFacturas: a.cantidadFacturas,
  fechaPago: a.fechaPago,
  saldo: a.saldo,
  coordenadas: a.coordenadas,
  customerFor: a.customerFor,
  POD: a.POD,

  direccionEntrega: a.direccionEntrega,
  fechaEntrega: a.fechaEntrega,
  horarioEntrega: a.horarioEntrega,
  contactoEntrega: a.contactoEntrega,
  observacionesEntrega: a.observacionesEntrega,

  rastreo: a.rastreo,
  mapa: a.mapa,
  fromCountry: a.fromCountry,
  polOrigen: a.polOrigen,
  loadingDate: a.loadingDate,
  departureDate: a.departureDate,
  toCountry: a.toCountry,
  podDestino: a.podDestino,
  arrivalDate: a.arrivalDate,
  dischargeDate: a.dischargeDate,
  vessel: a.vessel,
  vesselIMO: a.vesselIMO,
  vesselLatitude: a.vesselLatitude,
  vesselLongitude: a.vesselLongitude,
  vesselVoyage: a.vesselVoyage,
  polLatitude: a.polLatitude,
  polLongitude: a.polLongitude,
  podLatitude: a.podLatitude,
  podLongitude: a.podLongitude,

  statusSeguimiento: a.statusSeguimiento,
  mar: a.mar,
  fechaMar: a.fechaMar,
  observacionesMar: a.observacionesMar,
  piso: a.piso,
  fechaPiso: a.fechaPiso,
  observacionesPiso: a.observacionesPiso,
  revision: a.revision,
  fechaRevision: a.fechaRevision,
  observacionesRevision: a.observacionesRevision,
  modulacion: a.modulacion,
  fechaModulacion: a.fechaModulacion,
  observacionesModulacion: a.observacionesModulacion,
  libre: a.libre,
  fechaLibre: a.fechaLibre,
  observacionesLibre: a.observacionesLibre,

  fichaTecnicaArchivo: a.fichaTecnicaArchivo,
  fichaTecnica: a.fichaTecnicaArchivo,
  cargosLocales: a.cargosLocales,
  DODA: a.DODA,
  boleta: a.boleta,
  prealta: a.prealta,
  EIR: a.EIR,
  BLRevalidado: a.BLRevalidado,
  demorasCartas: a.demorasCartas,
  validacion: a.validacion,
  garantia: a.garantia,
  transporte: a.transporte,
  maniobras: a.maniobras,

  fechaBl: a.fechaBl,
  fechaPl: a.fechaPl,
  fechaEntradaPuerto: a.fechaEntradaPuerto,
  fechaDocumentos: a.fechaDocumentos,
  fechaTelex: a.fechaTelex,
  fechaToquePiso: a.fechaToquePiso,
  fechaRevalidacion: a.fechaRevalidacion,
  fechaFichaTecnica: a.fechaFichaTecnica,
  fechaPagoPedimento: a.fechaPagoPedimento,
  fechaRetornoVacio: a.fechaRetornoVacio,
  fechaSalidaPuerto: a.fechaSalidaPuerto,
  fechaSalidaRuta: a.fechaSalidaRuta,
  fechaEntregaCliente: a.fechaEntregaCliente,
  fechaFactura: a.fechaFactura,
  fechaManiobras: a.fechaManiobras,
  telex: a.telex,
  toquePiso: a.toquePiso,
  revalidacion: a.revalidacion,
  pagoPedimento: a.pagoPedimento,
  salidaPuerto: a.salidaPuerto,
  salidaRuta: a.salidaRuta,
  entregaCliente: a.entregaCliente,
  retornoVacio: a.retornoVacio,

  tipoContenedor: a.tipoContenedor || "",
  booking: a.booking || "",
  proveedor: a.proveedor || "",
  referenciaCliente: a.referenciaCliente || "",
  modalidad: a.modalidad || "",
  quienPaga: a.quienPaga || "",
  quienRevalida: a.quienRevalida || "",
  etapaViaje: a.etapaViaje || "",
  transbordos: a.transbordos || [],
};
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_CLIENTES}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_BROKERS}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allBrokers = response.data;
        setBrokers(allBrokers);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_FORWARDERS}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allForwarders = response.data;
        setForwarders(allForwarders);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(`${URL_NAVIERAS}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allNavieras = response.data;
        setNavieras(allNavieras);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [user, selectedFechaInicio, selectedFechaFin, selectedForwarder]);
// console.log("hola", user)
  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (selectedBroker == 0 || selectedBroker == a.idBrokers) &&
        (selectedForwarder == 0 || selectedForwarder == a.idForwarders) &&
        (selectedNaviera == 0 || selectedNaviera == a.idNaviera)&&
        (selectedSurtido == 0 || selectedSurtido == a.surtido)&&
        (selectedPrevio == 0 || selectedPrevio == a.previo)&&
        (selectedStatus == 0 || selectedStatus == a.statusSeguimiento)&&
        (!selectedEtapa || selectedEtapa == (a.etapaViaje || "Sin rastreo"))&&
        (!selectedPuertoDestino || selectedPuertoDestino == a.puertoDestino)&&
        (selectedPrioridad == 0 || selectedPrioridad == a.prioridad)&&
        (selectedPL == 0 || selectedPL == a.packing) &&
        (selectedBL == 0 || selectedBL == a.bl) &&
        (selectedActivo == 0 || selectedActivo == a.activo)
      ) {
        return [
          a.numero,
          a.fecha,
          a.numeroReferencia,
          a.referenciaExtra,
          a.referencia,
          a.naviera,
          a.buque,
          a.vessel,
          a.clientes,
          a.brokers,
          a.forwarders,
          // a.observaciones,
          // a.enMar,
          a.previo,
          a.surtido,
          a.flete,
          new Intl.NumberFormat("en-US").format(a.totalCantidad),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    const startY = pdfHeader(doc, "Listado Contenedores", `${selectedFechaInicio} - ${selectedFechaFin}`);
    doc.autoTable({
      ...pdfTableStyles(),
      head: [
        [
          "Numero",
          "Fecha",
          "Referencia",
          "Ref Extra",
          "Contenedor",
          "Naviera",
          "Buque",
          "Transbordo",
          "Cliente",
          "Broker",
          "Forwarder",
          // "Observaciones",
          // "Mar",
          "Previo",
          "Surtido",
          "Cantidad",
        ],
      ],
      body: dataPDFLimpia,
      startY: startY,
    });
    pdfFooter(doc);
    doc.save(`Contenedores.pdf`);
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (selectedBroker == 0 || selectedBroker == a.idBrokers) &&
        (selectedForwarder == 0 || selectedForwarder == a.idForwarders) &&
        (selectedNaviera == 0 || selectedNaviera == a.idNaviera)&&
        (selectedSurtido == 0 || selectedSurtido == a.surtido)&&
        (selectedPrevio == 0 || selectedPrevio == a.previo)&&
        (selectedStatus == 0 || selectedStatus == a.statusSeguimiento)&&
        (!selectedEtapa || selectedEtapa == (a.etapaViaje || "Sin rastreo"))&&
        (!selectedPuertoDestino || selectedPuertoDestino == a.puertoDestino)&&
        (selectedPrioridad == 0 || selectedPrioridad == a.prioridad)&&
        (selectedPL == 0 || selectedPL == a.packing)&&
        (selectedBL == 0 || selectedBL == a.bl)&&
        (selectedActivo == 0 || selectedActivo == a.activo)
      ) {
        return {
          Id: a._id,
          Numero: a.numero,
          Fecha: a.fecha,
          Referencia: a.numeroReferencia,
          // RefExtra: a.referenciaExtra,
          Contenedor: a.referencia,
          ETD: a.etd,
          ETAEst: a.etaEstimada,
          ETAReal: a.etaReal,
          FechaEntrega: a.fechaEntregaReal,
          Naviera: a.naviera,
          Buque: a.buque,
          PuertoDestino: a.puertoDestino,
          Transbordo: a.vessel,
          Cliente: a.clientes,
          Broker: a.brokers,
          Forwarder: a.forwarders,
          // Observaciones: a.observaciones,
          // Mar: a.enMar,
          Previo: a.previo,
          Surtido: a.surtido,
          Flete: a.flete,
          Cantidad: a.totalCantidad,
          Prioridad: a.prioridad
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoContenedores";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoContenedores",
        sheetFilter: [
          "Id",
          "Numero",
          "Fecha",
          "Referencia",
          // "RefExtra",
          "Contenedor",
          "ETD",
          "ETAEst",
          "ETAReal",
          "FechaEntrega",
          "Naviera",
          "Buque",
          "PuertoDestino",
          "Transbordo",
          "Cliente",
          "Broker",
          "Forwarder",
          // "Observaciones",
          // "Mar",
          "Previo",
          "Surtido",
          "Flete",
          "Cantidad",
          "Prioridad"
        ],
        sheetHeader: [
          "Id",
          "Numero",
          "Fecha",
          "Referencia",
          // "RefExtra",
          "Contenedor",
          "ETD",
          "ETAEst",
          "ETAReal",
          "FechaEntrega",
          "Naviera",
          "Buque",
          "PuertoDestino",
          "Transbordo",
          "Cliente",
          "Broker",
          "Forwarder",
          // "Observaciones",
          // "Mar",
          "Previo",
          "Surtido",
          "Flete",
          "Cantidad",
          "Prioridad"
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (selectedBroker == 0 || selectedBroker == a.idBrokers) &&
        (selectedForwarder == 0 || selectedForwarder == a.idForwarders) &&
        (selectedNaviera == 0 || selectedNaviera == a.idNaviera)&&
        (selectedSurtido == 0 || selectedSurtido == a.surtido)&&
        (selectedPrevio == 0 || selectedPrevio == a.previo)&&
        (selectedStatus == 0 || selectedStatus == a.statusSeguimiento)&&
        (!selectedEtapa || selectedEtapa == (a.etapaViaje || "Sin rastreo"))&&
        (!selectedPuertoDestino || selectedPuertoDestino == a.puertoDestino)&&
        (selectedPrioridad == 0 || selectedPrioridad == a.prioridad)&&
        (selectedPL == 0 || selectedPL == a.packing)&&
        (selectedBL == 0 || selectedBL == a.bl)&&
        (selectedActivo == 0 || selectedActivo == a.activo)
      ) {
        return [
          a.numero,
          a.fecha,
          a.numeroReferencia,
          a.referenciaExtra,
          a.referencia,
          a.naviera,
          a.buque,
          a.vessel,
          a.clientes,
          a.brokers,
          a.forwarders,
          // a.observaciones,
          // a.enMar,
          a.previo,
          a.surtido,
          new Intl.NumberFormat("en-US").format(a.totalCantidad),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    const startY = pdfHeader(doc, "Listado Contenedores", `${selectedFechaInicio} - ${selectedFechaFin}`);
    doc.autoTable({
      ...pdfTableStyles(),
      head: [
        [
          "Numero",
          "Fecha",
          "Referencia",
          "Ref Extra",
          "Contenedor",
          "Naviera",
          "Buque",
          "Buque",
          "Cliente",
          "Broker",
          "Forwarder",
          // "Observaciones",
          // "Mar",
          "Previo",
          "Surtido",
          "Cantidad",
        ],
      ],
      body: dataPDFLimpia,
      startY: startY,
    });
    pdfFooter(doc);
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Contenedores",
          email: mailTo,
          fileName: "ListadoContenedores.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Contenedores.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

      function importarArchivo(event){
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    let hojas = [];
   
    if (name === "file") {
  
      let reader = new FileReader();
        reader.readAsArrayBuffer(target.files[0]);
        reader.onloadend = (e) => {
          var data = new Uint8Array(e.target.result);
          var workbook = XLSX.read(data, { type: "array" });
  
          workbook.SheetNames.forEach(function (sheetName) {
            // Here is your object
            var XL_row_object = XLSX.utils.sheet_to_json(
              workbook.Sheets[sheetName]
            );
            hojas.push({
              data: XL_row_object,
              sheetName,
            });
          });
  
          let A1 = hojas[0].data
  
          let TC = totalCaptura
          A1.map((a)=>{
             TC = TC + 1
            setTotalCaptura(TC)
          inputFieldsFlete.push({
            id: uuidv4(),
            idCont: a.Id,
            flete: a.Flete
          })
          })
  
          // ActualizaTotales()
        }
    }
  }


  function jalaInfo(
    fecha,
    idClientes,
    idBrokers,
    idForwarders,
    totalCantidad,
    totalGeneral,
    observaciones,
    numeroContenedor,
    numeroReferencia,
    referenciaExtra,
    flete,
    incrementable,
    liberadoPor,
    idNaviera,
    buque,
    puertoDestino,
    direccionEntrega,
    fechaEntrega,
    horarioEntrega,
    contactoEntrega,
    observacionesEntrega,
    prioridad,
    referencia,
    etd,
    etaEstimada,
    etaReal,
    fechaLlegada,
    fechaLiberacion,
    fechaEntregaEstimada,
    fechaEntregaReal,
    aduana,
    rastreo,
    surtido,
    idEdit
  ) {
    setFecha(fecha);
    setSelectedClienteEdit(idClientes);
    setSelectedBrokerEdit(idBrokers);
    setSelectedForwarderEdit(idForwarders);
    setTotalCantidad(totalCantidad);
    setTotalGeneral(totalGeneral);
    setObservaciones(observaciones);
    setNumeroContenedor(numeroContenedor);
    setNumeroReferencia(numeroReferencia);
    setFlete(flete);
    setIncrementable(incrementable);
    setLiberadoPor(liberadoPor);
    setReferenciaExtra(referenciaExtra);
    setSelectedNavieraEdit(idNaviera);
    setBuque(buque);
    setPuertoDestino(puertoDestino);
    setDireccionEntrega(direccionEntrega);
    setFechaEntrega(fechaEntrega);
    setHorarioEntrega(horarioEntrega);
    setContactoEntrega(contactoEntrega);
    setObservacionesEntrega(observacionesEntrega);
    setPrioridad(prioridad);
    setReferencia(referencia);
    setFechaETD(etd);
    setFechaETAEstimada(etaEstimada);
    setFechaETAReal(etaReal);
    setFechaLlegada(fechaLlegada);
    setFechaLiberacion(fechaLiberacion);
    setFechaEntregaEstimada(fechaEntregaEstimada);
    setFechaEntregaReal(fechaEntregaReal);
    setAduana(aduana);
    setRastreo(rastreo);
    setSurtido(surtido);
    setIdEdit(idEdit);
    const actual = comments.find((x) => x._id === idEdit) || {};
    setEmbarqueEdit({
      _para: idEdit,
      puerto: actual.puerto && actual.puerto !== "NA" ? actual.puerto : "",
      blNumero: actual.blNumero && actual.blNumero !== "NA" ? actual.blNumero : "",
      tipoContenedor: actual.tipoContenedor || "",
      booking: actual.booking || "",
      proveedor: actual.proveedor || "",
      referenciaCliente: actual.referenciaCliente || "",
      modalidad: actual.modalidad || "",
      quienPaga: actual.quienPaga || "",
      quienRevalida: actual.quienRevalida || "",
    });
    toggleEdit();
  }

    function jalaInfoBroker(
    fecha,
    idClientes,
    idBrokers,
    idForwarders,
    totalCantidad,
    totalGeneral,
    observaciones,
    numeroContenedor,
    numeroReferencia,
    referenciaExtra,
    flete,
    incrementable,
    liberadoPor,
    idNaviera,
    buque,
    puertoDestino,
    direccionEntrega,
    fechaEntrega,
    horarioEntrega,
    contactoEntrega,
    observacionesEntrega,
    prioridad,
    referencia,
    etd,
    etaEstimada,
    etaReal,
    fechaLlegada,
    fechaLiberacion,
    fechaEntregaEstimada,
    fechaEntregaReal,
    aduana,
    rastreo,
    surtido,
    idEdit
  ) {
    setFecha(fecha);
    setSelectedClienteEdit(idClientes);
    setSelectedBrokerEdit(idBrokers);
    setSelectedForwarderEdit(idForwarders);
    setTotalCantidad(totalCantidad);
    setTotalGeneral(totalGeneral);
    setObservaciones(observaciones);
    setNumeroContenedor(numeroContenedor);
    setNumeroReferencia(numeroReferencia);
    setFlete(flete);
    setIncrementable(incrementable);
    setLiberadoPor(liberadoPor);
    setReferenciaExtra(referenciaExtra);
    setSelectedNavieraEdit(idNaviera);
    setBuque(buque);
    setPuertoDestino(puertoDestino);
    setDireccionEntrega(direccionEntrega);
    setFechaEntrega(fechaEntrega);
    setHorarioEntrega(horarioEntrega);
    setContactoEntrega(contactoEntrega);
    setObservacionesEntrega(observacionesEntrega);
    setPrioridad(prioridad);
    setReferencia(referencia);
    setFechaETD(etd);
    setFechaETAEstimada(etaEstimada);
    setFechaETAReal(etaReal);
    setFechaLlegada(fechaLlegada);
    setFechaLiberacion(fechaLiberacion);
    setFechaEntregaEstimada(fechaEntregaEstimada);
    setFechaEntregaReal(fechaEntregaReal);
    setAduana(aduana);
    setRastreo(rastreo);
    setSurtido(surtido);
    setIdEdit(idEdit);
    setEmbarqueEdit({ quienRevalida: (comments.find((x) => x._id === idEdit) || {}).quienRevalida || "" });
    toggleEditBroker();
  }

  async function PDFOC(
    fecha,
    clientes,
    brokers,
    forwarders,
    totalCantidad,
    totalGeneral,
    observaciones,
    numero,
    naviera,
    idPDFOC
  ) {
    await axios
      .get(`${URL_ARTICULOS_CONTENEDOR}/contenedor/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosContenedor = response.data;
        let arrayTabla = allArticulosContenedor
          .map((a) => {
            return {
              id: a._id,
              articulos: a.articulos[0].name,
              descripcion: a.descripcion,
              cantidad: a.cantidad,
              precio: a.precio,
              total: a.total,
              pendienteSurtir: a.pendienteSurtir,
              cantidadSurtido: a.cantidadSurtido,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        let cant = inputFields.map((c) => parseFloat(c.cantidad));
        let TC = cant.reduce((t, total, index) => t + total, 0);
        setTotalCantidad(TC);
        let importes = dataFinal.map((c) => parseFloat(c.total));
        let TG = importes.reduce((t, total, index) => t + total, 0);
        setTotalGeneralEdit(TG);

        const data = dataFinal.map((a) => {
          return [
            a.articulos,
            a.descripcion,
            new Intl.NumberFormat("en-US").format(a.cantidad),
            "$" + new Intl.NumberFormat("en-US").format(a.precio),
            "$" + new Intl.NumberFormat("en-US").format(a.total),
          ];
        });
        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });
        const doc = new jsPDF("landscape");
        const startY = pdfHeader(
          doc,
          `Contenedor # ${numero}`,
          `Fecha ${fecha}  |  Naviera ${naviera}  |  Piezas ${new Intl.NumberFormat("en-US").format(totalCantidad)}`
        );
        doc.autoTable({
          ...pdfTableStyles(),
          head: [["Articulo", "Descripcion", "Cantidad", "Precio", "Total"]],
          body: dataPDFLimpia,
          startY: startY,
          foot: [
            [
              "",
              "",
              "",
              "Total",
              "$" + new Intl.NumberFormat("en-US").format(totalGeneral),
            ],
          ],
          showFoot: "lastPage",
        });
        pdfFooter(doc);
        doc.save(`Contenedor-${numero}.pdf`);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function editContenedores(event) {
    event.preventDefault();
    const URL_CONTENEDORES_EDIT = `${process.env.REACT_APP_URL_CONTENEDORES}/${idEdit}`;

    // Los datos del embarque solo viajan si se abrió la edición completa de este contenedor;
    // desde la sección de broker solo viaja quién revalida
    const embarque = embarqueEdit._para === idEdit
      ? { ...embarqueEdit, _para: undefined, blNumero: embarqueEdit.blNumero || "NA", puerto: embarqueEdit.puerto || "NA" }
      : { quienRevalida: embarqueEdit.quienRevalida };
    guardaConAvisos((confirmado) => axios
      .patch(
        URL_CONTENEDORES_EDIT,
        {
          confirmado,
          ...embarque,
          fecha,
          clientes: selectedClienteEdit,
          brokers: selectedBrokerEdit,
          forwarders: selectedForwarderEdit,
          observaciones,
          numeroReferencia,
          flete,
          incrementable,
          liberadoPor,
          referenciaExtra,
          navieras: selectedNavieraEdit,
          buque,
          puertoDestino,
          direccionEntrega,
          fechaEntrega,
          horarioEntrega,
          contactoEntrega,
          observacionesEntrega,
          prioridad,
          referencia,
          etd: fechaETD,
          etaEstimada: fechaETAEstimada,
          etaReal: fechaETAReal,
          fechaLlegada: fechaLlegada,
          fechaLiberacion: fechaLiberacion,
          fechaEntregaEstimada: fechaEntregaEstimada,
          fechaEntregaReal: sinFecha(fechaEntregaReal) ? "" : fechaEntregaReal,
          aduana,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      ))
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Contenedor",
            detalle: `${numeroContenedor} ${fecha}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );

        if (modalEditBroker) toggleEditBroker();
        else toggleEdit();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        if (error.cancelado) return;
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error?.response?.data?.message || "Something went wrong!",
        });
        console.log(error);
      });
  }

  function guardaFlete(event) {
    event.preventDefault();

    let totalFlete = inputFieldsFlete.length



    inputFieldsFlete.map((a) => {
      axios
        .patch(
          `${URL_CONTENEDORES}/${a.idCont}`,
          {
            flete: a.flete
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem(
                "app_token"
              )}`,
            },
          }
        )
        .then(() => {
          totalFlete = totalFlete - 1;
          if (totalFlete == 0) {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Editar Flete",
                  detalle: `Subir Fletes`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                Swal.fire("Good job!", "Creado con exito", "success");
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    });
  }

  const headers = [
    { name: `${t("Numero")}`, field: "numero", sortable: true },
    { name: `${t("Fecha")}`, field: "fecha", sortable: true },
    { name: `${t("No. Referencia")}`, field: "numeroReferencia", sortable: true},
    { name: `${t("Contenedor")}`, field: "referencia", sortable: true },
    { name: `${t("Naviera")}`, field: "naviera", sortable: true },
    { name: `${t("Buque")}`, field: "buque", sortable: true },
    { name: `${t("Puerto Destino")}`, field: "puertoDestino", sortable: true },
    { name: `${t("Transbordo")}`, field: "vessel", sortable: true },
    { name: `${t("Cliente")}`, field: "clientes", sortable: true },
    { name: `${t("Broker")}`, field: "brokers", sortable: true },
    { name: `${t("Forwarder")}`, field: "forwarders", sortable: true },
    { name: `${t("ETD")}`, field: "etd", sortable: true },
    { name: `${t("ETA Estimada")}`, field: "etaEstimada", sortable: true },
    { name: `${t("ETA Actualizada")}`, field: "etaReal", sortable: true },
    { name: `${t("Cantidad")}`, field: "totalCantidad", sortable: true },
    { name: `${t("Flete")}`, field: "flete", sortable: true },
    { name: `${t("Incrementable")}`, field: "incrementable", sortable: true },
    // { name: `${t("Surtido")}`, field: "totalSurtido", sortable: true },
    // { name: `${t("Pend Surtir")}`, field: "pendienteSurtir", sortable: true },
    // { name: `${t("Total")}`, field: "totalGeneral", sortable: true },
    // { name: `${t("En Mar")}`, field: "enMar", sortable: false },
    { name: `${t("Entregado")}`, field: "surtido", sortable: false },
    { name: `${t("Status")}`, field: "statusSeguimiento", sortable: false },
    { name: `${t("Etapa del viaje")}`, field: "etapaViaje", sortable: true },
    { name: `${t("Fecha Entrega")}`, field: "fechaEntregaReal", sortable: true },
    { name: `${t("Prioridad")}`, field: "prioridad", sortable: true },
    { name: `${t("Detalle Piezas")}`, field: "PDF", sortable: false },
    { name: `${t("Status")}`, field: "status", sortable: false },
    { name: `${t("Previo")}`, field: "previo", sortable: false },
    { name: `${t("PL")}`, field: "pl", sortable: false },
    { name: `${t("BL")}`, field: "bl", sortable: false },
    { name: `${t("Editar")}`, field: "editar", sortable: false },
    { name: `${t("Cancelar")}`, field: "cancelar", sortable: false },
  ];

  // Al bajar por la tabla se esconde lo de arriba y solo quedan fijos los títulos; al volver al inicio regresa.
  function scrollTabla(e) {
    const el = e.currentTarget;
    if (el.scrollTop > 40 && el.scrollHeight > window.innerHeight) setTablaCompacta(true);
    else if (el.scrollTop === 0) setTablaCompacta(false);
  }

  const puertosDestino = useMemo(
    () =>
      [...new Set(comments.map((c) => c.puertoDestino).filter((p) => p && p !== "NA"))].sort(),
    [comments]
  );

  const commentsData = useMemo(() => {
    let computedComments = comments;

    // if (search) {
    //   computedComments = computedComments.filter(
    //     (comment) =>
    //       comment.numeroReferencia
    //         .toLowerCase()
    //         .includes(search.toLowerCase()) ||
    //       comment.referenciaExtra.toLowerCase().includes(search.toLowerCase()) ||
    //       comment.referencia.toLowerCase().includes(search.toLowerCase()) ||
    //       comment.naviera.toLowerCase().includes(search.toLowerCase()) ||
    //       comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
    //       comment.brokers.toLowerCase().includes(search.toLowerCase()) ||
    //       comment.forwarders.toLowerCase().includes(search.toLowerCase()) ||
    //       // comment.enMar.toLowerCase().includes(search.toLowerCase()) ||
    //       comment.surtido.toLowerCase().includes(search.toLowerCase()) ||
    //       comment.incrementable.toLowerCase().includes(search.toLowerCase()) ||
    //       comment.buque.toLowerCase().includes(search.toLowerCase()) ||
    //       comment.vessel.toLowerCase().includes(search.toLowerCase()) ||
    //       comment.totalCantidad.toString().includes(search) ||
    //       comment.prioridad.toString().includes(search) ||
    //       comment.totalGeneral.toString().includes(search) ||
    //       comment.flete.toString().includes(search) ||
    //       comment.numero.toString().includes(search)
    //   );
    // }

    if (search && search.length > 0) {
      computedComments = computedComments.filter((comment) => 
        search.some(term =>
          comment.numeroReferencia.toLowerCase().includes(term.toLowerCase()) ||
          comment.referenciaExtra.toLowerCase().includes(term.toLowerCase()) ||
          comment.referencia.toLowerCase().includes(term.toLowerCase()) ||
          comment.naviera.toLowerCase().includes(term.toLowerCase()) ||
          comment.clientes.toLowerCase().includes(term.toLowerCase()) ||
          comment.brokers.toLowerCase().includes(term.toLowerCase()) ||
          comment.forwarders.toLowerCase().includes(term.toLowerCase()) ||
          comment.surtido.toLowerCase().includes(term.toLowerCase()) ||
          comment.incrementable.toLowerCase().includes(term.toLowerCase()) ||
          comment.liberadoPor.toLowerCase().includes(term.toLowerCase()) ||
          comment.buque.toLowerCase().includes(term.toLowerCase()) ||
          comment.puertoDestino.toLowerCase().includes(term.toLowerCase()) ||
          comment.vessel.toLowerCase().includes(term.toLowerCase()) ||
          comment.totalCantidad.toString().includes(term) ||
          comment.prioridad.toString().includes(term) ||
          comment.totalGeneral.toString().includes(term) ||
          comment.flete.toString().includes(term) ||
          comment.numero.toString().includes(term)
        )
      );
    }
    

    if (selectedBroker) {
      computedComments = computedComments.filter((e) =>
        e.idBrokers.includes(selectedBroker)
      );
    }

    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idClientes.includes(selectedCliente)
      );
    }

    if (selectedForwarder) {
      computedComments = computedComments.filter((e) =>
        e.idForwarders.includes(selectedForwarder)
      );
    }

    if (selectedNaviera) {
      computedComments = computedComments.filter((e) =>
        e.idNaviera.includes(selectedNaviera)
      );
    }

    if (selectedSurtido) {
      computedComments = computedComments.filter((e) =>
        e.surtido.includes(selectedSurtido)
      );
    }
    // if (selectedEnMar) {
    //   computedComments = computedComments.filter((e) =>
    //     e.enMar.includes(selectedEnMar)
    //   );
    // }

    if (selectedStatus) {
      computedComments = computedComments.filter((e) =>
        e.statusSeguimiento.includes(selectedStatus)
      );
    }
    if (selectedEtapa) {
      computedComments = computedComments.filter(
        (e) => (e.etapaViaje || "Sin rastreo") === selectedEtapa
      );
    }
    if (selectedPuertoDestino) {
      computedComments = computedComments.filter(
        (e) => e.puertoDestino === selectedPuertoDestino
      );
    }
    
    if (selectedPrioridad !== null && selectedPrioridad !== undefined && selectedPrioridad !== "") {
      computedComments = computedComments.filter(
        (e) => e.prioridad === selectedPrioridad
      );
    }
    if (selectedPrevio) {
      computedComments = computedComments.filter((e) =>
        e.previo.includes(selectedPrevio)
      );
    }
    if (selectedPL) {
      computedComments = computedComments.filter((e) =>
        e.packing.includes(selectedPL)
      );
    }
    if (selectedBL) {
      computedComments = computedComments.filter((e) =>
        e.bl.includes(selectedBL)
      );
    }
    if (selectedActivo) {
      computedComments = computedComments.filter((e) =>
        e.activo.includes(selectedActivo)
      );
    }
    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "totalCantidad" &&
      sorting.field != "totalSurtido" &&
      sorting.field != "pendienteSurtir" &&
      sorting.field != "totalGeneral" &&
      sorting.field != "flete" &&
      sorting.field != "prioridad" &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "totalCantidad" ||
        sorting.field != "totalSurtido" ||
        sorting.field != "pendienteSurtir" ||
        sorting.field == "totalGeneral" ||
        sorting.field == "flete" ||
        sorting.field == "prioridad" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "totalCantidad" ||
        sorting.field != "totalSurtido" ||
        sorting.field != "pendienteSurtir" ||
        sorting.field == "totalGeneral" ||
        sorting.field == "flete" ||
        sorting.field == "prioridad" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedFechaInicio,
    selectedFechaFin,
    selectedBroker,
    selectedCliente,
    selectedForwarder,
    selectedNaviera,
    selectedSurtido,
    // selectedEnMar,
    selectedPrevio,
    selectedStatus,
    selectedEtapa,
    selectedPuertoDestino,
    selectedPrioridad,
    selectedPL,
    selectedBL,
    selectedActivo,
  ]);


  function EditArticulos(idOC, numeroContenedor, idClientes, idBrokers, idNavieras) {
    setInputFields([
      {
        id: uuidv4(),
        articulos: "",
        descripcion: "",
        cantidad: 0,
        precio: 0,
        total: 0,
      },
    ]);
    setIdEdit(idOC);
    setNumeroContenedor(numeroContenedor);
    setIdClientesEdit(idClientes);
    setIdBrokersEdit(idBrokers);
    setIdNavierasEdit(idNavieras);
    axios
      .get(`${URL_ARTICULOS_CONTENEDOR}/contenedor/${idOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosContenedor = response.data;
        let arrayTabla = allArticulosContenedor
          .map((a) => {
            return {
              id: a._id,
              articulos: a.articulos[0]._id,
              cantidad: a.cantidad,
              precio: a.precio,
              total: a.total,
              pendienteSurtir: a.pendienteSurtir,
              cantidadSurtido: a.cantidadSurtido, descripcion: a.descripcion,
              proveedor: a.proveedor,
              marca: a.marca,
              PO: a.PO,
              CBMS: a.CBMS,
            };
          })
          .filter(function (el) {
            return el != null;
          });
        let dataFinal = Object.values(arrayTabla);
        setArticulosContenedor(dataFinal);

        let cant = dataFinal.map((c) => parseFloat(c.cantidad));
        let TC = cant.reduce((t, total, index) => t + total, 0);
        setTotalCantidadEdit(TC);
        let importes = dataFinal.map((c) => parseFloat(c.total));
        let TG = importes.reduce((t, total, index) => t + total, 0);
        setTotalGeneralEdit(TG);
      })
      .catch((err) => {
        console.log(err);
      });
    toggleEditArticulos();
  }

  const handleChangeInputExistentes = (id, event) => {
    const newArticulosContenedor = articulosContenedor.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setArticulosContenedor(newArticulosContenedor);
    ActualizaTotales();
  };

  const handleChangeInputExistentesCantidad = (id, event) => {
    const newArticulosContenedor = articulosContenedor.map((i) => {
      if (id === i.id) {
        let PR =
          parseFloat(i.pendienteSurtir) -
          parseFloat(i.cantidad) +
          parseFloat(event.target.value);
        i.pendienteSurtir = PR;
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setArticulosContenedor(newArticulosContenedor);
    ActualizaTotales();
  };

  function BuscaArticuloExistentes(id, event) {
    articulos.map((a) => {
      if (a._id == event.target.value) {
        let idArticulo = a._id;
        handleChangeInputExistentesArticulo(id, idArticulo);
      }
    });
  }

  const handleChangeInputExistentesArticulo = (id, idArticulo) => {
    const newArticulosContenedor = articulosContenedor.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setArticulosContenedor(newArticulosContenedor);
    ActualizaTotales();
  };

  const handleAddFields = () => {
    const ultimo = inputFields[inputFields.length - 1];
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: ultimo.articulos,
        cantidad: 0,
        precio: ultimo.precio,
        total: 0,
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let cantidadExistentes = articulosContenedor.map((c) =>
      parseFloat(c.cantidad)
    );
    let cantidadNuevos = values.map((c) => parseFloat(c.cantidad));
    let cantidad = cantidadExistentes.concat(cantidadNuevos);
    let TC = cantidad.reduce((t, total, index) => t + total, 0);
    setTotalCantidadEdit(TC);

    let importesExistentes = articulosContenedor.map((c) =>
      parseFloat(c.total)
    );
    let importesNuevos = values.map((c) => parseFloat(c.total));
    let importes = importesExistentes.concat(importesNuevos);
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneralEdit(TG);
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function BuscaArticulo(id, event) {
    articulos.map((a) => {
      if (a._id == event.target.value) {
        let idArticulo = a._id;
        handleChangeInputArticulo(id, idArticulo);
      }
    });
  }

  const handleChangeInputArticulo = (id, idArticulo) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function ActualizaTotales() {
    let cantidadExistentes = articulosContenedor.map((c) =>
      parseFloat(c.cantidad)
    );
    let cantidadNuevos = inputFields.map((c) => parseFloat(c.cantidad));
    let cantidad = cantidadExistentes.concat(cantidadNuevos);
    let TC = cantidad.reduce((t, total, index) => t + total, 0);
    setTotalCantidadEdit(TC);

    let importesExistentes = articulosContenedor.map((c) =>
      parseFloat(c.total)
    );
    let importesNuevos = inputFields.map((c) => parseFloat(c.total));
    let importes = importesExistentes.concat(importesNuevos);
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneralEdit(TG);
  }

  const saveContenedor = async (event) => {
    event.preventDefault();
    toggleProgreso();

    let totalArticulos = inputFields.length + articulosContenedor.length;

    const URL_CONTENEDORES_EDIT = `${process.env.REACT_APP_URL_CONTENEDORES}/${idEdit}`;
    try {
      await axios
        .patch(
          URL_CONTENEDORES_EDIT,
          {
            totalGeneral: totalGeneral_edit,
            totalCantidad: totalCantidad_edit,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          inputFields.map((a) => {
            if (a.articulos != "" && a.cantidad > 0) {
              axios
                .post(
                  URL_ARTICULOS_CONTENEDOR,
                  {
                    contenedores: idEdit,
                    articulos: a.articulos,
                    cantidad: parseFloat(a.cantidad),
                    cantidadSurtido:0,
                    pendienteSurtir: parseFloat(a.cantidad),
                    precio: parseFloat(a.precio),
                    total: parseFloat(a.total),
                    descripcion: a.descripcion,
                    proveedor: a.proveedor,
                    marca: a.marca,
                    PO: a.PO,
                    CBMS: a.CBMS,
                    fecha: fechaEditArticulos,
                    clientes: idClientesEdit,

                    brokers: idBrokersEdit,
                    navieras: idNavierasEdit,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalArticulos = totalArticulos - 1;
                  if (totalArticulos == 0) {
                    axios
                      .post(
                        URL_LOGS,
                        {
                          tipo: "Editar Contenedor",
                          detalle: `${numeroContenedor}`,
                          user: user.id,
                        },
                        {
                          headers: {
                            Authorization: `Bearer: ${localStorage.getItem(
                              "app_token"
                            )}`,
                          },
                        }
                      )
                      .then(() => {
                        Swal.fire("Good job!", "Creado con exito", "success");
                        setTimeout(() => {
                          window.location.reload();
                        }, 1000);
                      })
                      .catch((error) => {
                        Swal.fire({
                          icon: "error",
                          title: "Oops...",
                          text: "Something went wrong!",
                          footer: `${error.response.data}`,
                        });
                        console.log(error);
                      });
                  }
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
              // cerrar if
            } else {
              totalArticulos = totalArticulos - 1;
              if (totalArticulos == 0) {
                axios
                  .post(
                    URL_LOGS,
                    {
                      tipo: "Editar Contenedor",
                      detalle: `${numeroContenedor}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    Swal.fire("Good job!", "Creado con exito", "success");
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      footer: `${error.response.data}`,
                    });
                    console.log(error);
                  });
              }
            }
          });

          articulosContenedor.map((a) => {
            axios
              .patch(
                `${URL_ARTICULOS_CONTENEDOR}/${a.id}`,
                {
                  articulos: a.articulos,
                  cantidad: parseFloat(a.cantidad),
                  precio: parseFloat(a.precio),
                  total: parseFloat(a.total),
                  pendienteSurtir: parseFloat(a.cantidad),
                  descripcion: a.descripcion,
                  proveedor: a.proveedor,
                  marca: a.marca,
                  PO: a.PO,
                  CBMS: a.CBMS,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalArticulos = totalArticulos - 1;
                if (totalArticulos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Editar Contenedor",
                        detalle: `${numeroContenedor}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                    });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  };

  // function marcar(id) {
  //   Swal.fire({
  //     title: "Estas seguro?",
  //     text: "Se va a marcar!",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "Si, marcar!",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       axios
  //         .patch(
  //           `${URL_CONTENEDORES}/${id}`,
  //           {
  //             enMar: "Si",
  //           },
  //           {
  //             headers: {
  //               Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //             },
  //           }
  //         )
  //         .then((response) => {
  //           Swal.fire({
  //             position: "center",
  //             icon: "success",
  //             title: "Se Actualizo",
  //             showConfirmButton: false,
  //             timer: 2000,
  //           });
  //           setTimeout(() => {
  //             window.location.reload();
  //           }, 1000);
  //         })
  //         .catch((error) => {
  //           Swal.fire({
  //             icon: "error",
  //             title: "Oops...",
  //             text: "Something went wrong!",
  //             footer: `${error.response.data}`,
  //           });
  //           console.log(error);
  //         });
  //     }
  //   });
  // }

  // function desMarcar(id) {
  //   Swal.fire({
  //     title: "Estas seguro?",
  //     text: "Se quitara la facturacion!",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "Si, quitar!",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       axios
  //         .patch(
  //           `${URL_CONTENEDORES}/${id}`,
  //           {
  //             enMar: "No",
  //           },
  //           {
  //             headers: {
  //               Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //             },
  //           }
  //         )
  //         .then((response) => {
  //           Swal.fire({
  //             position: "center",
  //             icon: "success",
  //             title: "Se actualizo",
  //             showConfirmButton: false,
  //             timer: 2000,
  //           });
  //           setTimeout(() => {
  //             window.location.reload();
  //           }, 1000);
  //         })
  //         .catch((error) => {
  //           Swal.fire({
  //             icon: "error",
  //             title: "Oops...",
  //             text: "Something went wrong!",
  //             footer: `${error.response.data}`,
  //           });
  //           console.log(error);
  //         });
  //     }
  //   });
  // }

  function cancelarContenedor(idContenedor) {
    Swal.fire({
      title: `${t("Estas seguro?")}`,
      text: `${t("Se cancelara el Contenedor!")}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `${t("Si, Cancelar!")}`,
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .get(`${URL_CONTENEDORES}Cancel/${idContenedor}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then(() => {
            Swal.fire("Good job!", "Enviado con exito", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  function guardaFotos() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              previo: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");
                setTimeout(() => {
                  // window.location.reload();
                }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }


  function borrarFoto(id) {

    axios.post(`${URL_DELMEDIA}/${id}`, {}, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })

    .then(() => {

      Swal.fire("Good job!", "Actualizado con exito", "success");
      setTimeout(() => {
        window.location.reload();
      }, 1000);

    })
    .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    });
    

    // setFile();
    // setPhoto([]);
  }
 function jalaFoto(idCont) {
  setPhoto([]);
  setIdContenedor(idCont);
  toggleFoto();

  const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_CONTENEDORES}/${idCont}`;

  axios
    .get(URL_GET_MEDIA, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      setPhoto(response?.data?.resources || []);
    })
    .catch((err) => {
      console.log(err);
      setPhoto([]);
    });
}

  // Foto Packing
  function guardaFotosPacking() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_PACKING, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              packing: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");
                setTimeout(() => {
                  // window.location.reload();
                }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

function jalaFotoPacking(idCont) {
  setPhoto([]);
  setIdContenedor(idCont);
  toggleFotoPacking();

  const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_PACKING}/${idCont}`;

  axios
    .get(URL_GET_MEDIA, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      setPhoto(response?.data?.resources || []);
    })
    .catch((err) => {
      console.log(err);
      setPhoto([]);
    });
}
  function guardaFotosBL() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_BL, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              bl: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");
                setTimeout(() => {
                  // window.location.reload();
                }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

function jalaFotoBL(idCont) {
  setPhoto([]);
  setIdContenedor(idCont);
  toggleFotoBL();

  const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_BL}/${idCont}`;

  axios
    .get(URL_GET_MEDIA, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      setPhoto(response?.data?.resources || []);
    })
    .catch((err) => {
      console.log(err);
      setPhoto([]);
    });
}

  function guardaFotosInvoice() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_INVOICE, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              invoice: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");
                setInvoice("Si");
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoInvoice(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_INVOICE}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
        // console.log("hola2", data.data.resources)
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoInvoice();
  }

        // Foto FichaTecnica
        function guardaFotosFichaTecnica() {
          file.map((a)=>{
          const formData = new FormData();
          formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
          formData.append("contenedor", idContenedor);
        
          axios
            .post(URL_UPMEDIA_FICHA_TECNICA, formData, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
              },
              params: {
                resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
              },
            })
            .then((response) => {
              axios
                .patch(
                  `${URL_CONTENEDORES}/${idContenedor}`,
                  {
                    fichaTecnicaArchivo: "Si",
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    },
                  }
                )
                .then((response) => {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Contenedor",
                        detalle: `Subir Foto`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                        },
                      }
                    )
                    .then((response) => {
                      Swal.fire("Good job!", "Actualizado con éxito", "success");
                      setFichaTecnicaArchivo("Si");
                      // setTimeout(() => {
                      //   window.location.reload();
                      // }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                    });
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
          })
          setFile();
          setPhoto([]);
        }
      
        function jalaFotoFichaTecnica(idCont) {
          setPhoto([])
          const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_FICHA_TECNICA}/${idCont}`;
          axios
            .get(URL_GET_MEDIA, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((data) => {
              setPhoto(data.data.resources);
              // console.log("hola2", data.data.resources)
            })
            .catch((err) => console.log(err));
          setIdContenedor(idCont);
      
      
          toggleFotoFichaTecnica();
        }


              // Foto Cargos Locales
  function guardaFotosCargosLocales() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_CARGOS_LOCALES, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              cargosLocales: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");
                setCargosLocales("Si");
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoCargosLocales(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_CARGOS_LOCALES}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
        // console.log("hola2", data.data.resources)
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoCargosLocales();
  }

        // Foto DODA
        function guardaFotosDODA() {
          file.map((a)=>{
          const formData = new FormData();
          formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
          formData.append("contenedor", idContenedor);
        
          axios
            .post(URL_UPMEDIA_DODA, formData, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
              },
              params: {
                resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
              },
            })
            .then((response) => {
              axios
                .patch(
                  `${URL_CONTENEDORES}/${idContenedor}`,
                  {
                    DODA: "Si",
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    },
                  }
                )
                .then((response) => {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Contenedor",
                        detalle: `Subir Foto`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                        },
                      }
                    )
                    .then((response) => {
                      Swal.fire("Good job!", "Actualizado con éxito", "success");
                      setDODA("Si");
                      // PackingsetTimeout(() => {
                      //   window.location.reload();
                      // }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                    });
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
          })
          setFile();
          setPhoto([]);
        }
      
        function jalaFotoDODA(idCont) {
          setPhoto([])
          const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_DODA}/${idCont}`;
          axios
            .get(URL_GET_MEDIA, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((data) => {
              setPhoto(data.data.resources);
              // console.log("hola2", data.data.resources)
            })
            .catch((err) => console.log(err));
          setIdContenedor(idCont);
      
      
          toggleFotoDODA();
        }

              // Foto Boleta
  function guardaFotosBoleta() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_BOLETA, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              boleta: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");
                setBoleta("Si");
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoBoleta(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_BOLETA}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
        // console.log("hola2", data.data.resources)
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoBoleta();
  }

        // Foto Prealta
        function guardaFotosPrealta() {
          file.map((a)=>{
          const formData = new FormData();
          formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
          formData.append("contenedor", idContenedor);
        
          axios
            .post(URL_UPMEDIA_PREALTA, formData, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
              },
              params: {
                resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
              },
            })
            .then((response) => {
              axios
                .patch(
                  `${URL_CONTENEDORES}/${idContenedor}`,
                  {
                    prealta: "Si",
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    },
                  }
                )
                .then((response) => {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Contenedor",
                        detalle: `Subir Foto`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                        },
                      }
                    )
                    .then((response) => {
                      Swal.fire("Good job!", "Actualizado con éxito", "success");
                      setPrealta("Si");
                      // setTimeout(() => {
                      //   window.location.reload();
                      // }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                    });
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
          })
          setFile();
          setPhoto([]);
        }
      
        function jalaFotoPrealta(idCont) {
          setPhoto([])
          const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_PREALTA}/${idCont}`;
          axios
            .get(URL_GET_MEDIA, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((data) => {
              setPhoto(data.data.resources);
              // console.log("hola2", data.data.resources)
            })
            .catch((err) => console.log(err));
          setIdContenedor(idCont);
      
      
          toggleFotoPrealta();
        }

              // Foto EIR
  function guardaFotosEIR() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_EIR, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              EIR: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");
                setEIR("Si");
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoEIR(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_EIR}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
        // console.log("hola2", data.data.resources)
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoEIR();
  }

                // Foto BLRevalidado
  function guardaFotosBLRevalidado() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_BLREVALIDADO, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              BLRevalidado: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");
                setBLRevalidado("Si");
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoBLRevalidado(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_BLREVALIDADO}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
        // console.log("hola2", data.data.resources)
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoBLRevalidado();
  }

                // Foto Demoras y Cartas
  function guardaFotosDemorasCartas() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_DEMORAS_CARTAS, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              demorasCartas: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");
                setDemorasCartas("Si");
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoDemorasCartas(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_DEMORAS_CARTAS}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
        // console.log("hola2", data.data.resources)
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoDemorasCartas();
  }

    // Foto Validacion
    function guardaFotosValidacion() {
      file.map((a)=>{
      const formData = new FormData();
      formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
      formData.append("contenedor", idContenedor);
    
      axios
        .post(URL_UPMEDIA_VALIDACION, formData, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
          },
          params: {
            resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
          },
        })
        .then((response) => {
          axios
            .patch(
              `${URL_CONTENEDORES}/${idContenedor}`,
              {
                validacion: "Si",
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then((response) => {
              axios
                .post(
                  URL_LOGS,
                  {
                    tipo: "Contenedor",
                    detalle: `Subir Foto`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    },
                  }
                )
                .then((response) => {
                  Swal.fire("Good job!", "Actualizado con éxito", "success");
                  setValidacion("Si");
                  // setTimeout(() => {
                  //   window.location.reload();
                  // }, 1000);
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
      })
      setFile();
      setPhoto([]);
    }
  
    function jalaFotoValidacion(idCont) {
      setPhoto([])
      const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_VALIDACION}/${idCont}`;
      axios
        .get(URL_GET_MEDIA, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((data) => {
          setPhoto(data.data.resources);
          // console.log("hola2", data.data.resources)
        })
        .catch((err) => console.log(err));
      setIdContenedor(idCont);
  
  
      toggleFotoValidacion();
    }

      // Foto Garantia
  function guardaFotosGarantia() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_GARANTIA, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              garantia: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");
                setGarantia("Si");
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoGarantia(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_GARANTIA}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
        // console.log("hola2", data.data.resources)
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoGarantia();
  }

    // Foto Transporte
    function guardaFotosTransporte() {
      file.map((a)=>{
      const formData = new FormData();
      formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
      formData.append("contenedor", idContenedor);
    
      axios
        .post(URL_UPMEDIA_TRANSPORTE, formData, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
          },
          params: {
            resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
          },
        })
        .then((response) => {
          axios
            .patch(
              `${URL_CONTENEDORES}/${idContenedor}`,
              {
                transporte: "Si",
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then((response) => {
              axios
                .post(
                  URL_LOGS,
                  {
                    tipo: "Contenedor",
                    detalle: `Subir Foto`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    },
                  }
                )
                .then((response) => {
                  Swal.fire("Good job!", "Actualizado con éxito", "success");
                  setTransporte("Si");
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
      })
      setFile();
      setPhoto([]);
    }
  
    function jalaFotoTransporte(idCont) {
      setPhoto([])
      const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_TRANSPORTE}/${idCont}`;
      axios
        .get(URL_GET_MEDIA, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((data) => {
          setPhoto(data.data.resources);
          // console.log("hola2", data.data.resources)
        })
        .catch((err) => console.log(err));
      setIdContenedor(idCont);
  
  
      toggleFotoTransporte();
    }

  async function registrarSG(id, idNaviera, contenedor) {

    axios
    .patch(
      `${URL_CONTENEDORES}AltaRastreo/${id}`,
      {
        navieras: idNaviera,
        contenedor: contenedor
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem(
            'app_token'
          )}`,
        },
      }
    )
    .then(() => {
      Swal.fire('Good job!', 'Creado con exito', 'success');
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    })
    .catch((error) => {
      Swal.fire({
        icon: 'error',
        title: 'No se dio de alta en ShipsGo',
        text: error.response?.data?.message || 'Something went wrong!',
      });
      console.log(error);
    });
    
  }

  function crearMapa(polLatitude,
    polLongitude,
    podLatitude,
    podLongitude,
    vesselLatitude,
    vesselLongitude,
    etaReal
  ){

const etaRealDate = new Date(etaReal)
etaRealDate.setHours(0, 0, 0, 0);
hoy.setHours(0, 0, 0, 0);
  const diasDiferencia = Math.floor((Date.UTC(etaRealDate.getFullYear(), etaRealDate.getMonth(), etaRealDate.getDate()) - 
                                   Date.UTC(hoy.getFullYear(), hoy.getMonth(), hoy.getDate())) / (1000 * 60 * 60 * 24));

    setDiasLlegada(diasDiferencia)

    setOriginCoords([polLatitude, polLongitude]);  // Ningbo, China (puerto de origen)
    setVesselCoords([vesselLatitude, vesselLongitude]);  // Posición actual del barco
    setDestinationCoords([podLatitude, podLongitude]);  // Lázaro Cárdenas, México (puerto de destino)
  
    // Ruta con puntos intermedios
    setCoordenadasMapa([
      // [polLatitude, polLongitude], 
      [vesselLatitude, vesselLongitude], 
      [podLatitude, podLongitude],
      // [30, 140],  // Punto intermedio 1 en el océano
      // [40, -160],
      // [20, -130],  // Punto intermedio 2 en el océano
    ]);

    toggleMapa()
  }

function EditStatus(data) {
  setId(data.id);

  setStatusSeguimiento(data.statusSeguimiento || "Abierto");

  setMar(data.mar || "No");
  setFechaMar(data.fechaMar || "");
  setObservacionesMar(data.observacionesMar || "NA");

  setPiso(data.piso || "No");
  setFechaPiso(data.fechaPiso || "");
  setObservacionesPiso(data.observacionesPiso || "NA");

  setRevision(data.revision || "No");
  setFechaRevision(data.fechaRevision || "");
  setObservacionesRevision(data.observacionesRevision || "NA");

  setModulacion(data.modulacion || "No");
  setFechaModulacion(data.fechaModulacion || "");
  setObservacionesModulacion(data.observacionesModulacion || "NA");

  setLibre(data.libre || "No");
  setFechaLibre(data.fechaLibre || "");
  setObservacionesLibre(data.observacionesLibre || "NA");

  setBl(data.bl || "No");
  setFechaBl(data.fechaBl || "");

  setPl(data.pl || "No");
  setFechaPl(data.fechaPl || "");

  setFacturado(data.facturado || "No");
  setFechaFactura(data.fechaFactura || "");

  setFichaTecnicaArchivo(data.fichaTecnicaArchivo || "No");
  setFechaFichaTecnica(data.fechaFichaTecnica || "");

  setFechaEntradaPuerto(data.fechaEntradaPuerto || "");
  setFechaDocumentos(data.fechaDocumentos || "");
  setFechaTelex(data.fechaTelex || "");
  setFechaToquePiso(data.fechaToquePiso || "");
  setFechaRevalidacion(data.fechaRevalidacion || "");
  setFechaPagoPedimento(data.fechaPagoPedimento || "");
  setFechaRetornoVacio(data.fechaRetornoVacio || "");
  setFechaSalidaPuerto(data.fechaSalidaPuerto || "");
  setFechaSalidaRuta(data.fechaSalidaRuta || "");
  setFechaEntregaCliente(data.fechaEntregaCliente || "");

  setCargosLocales(data.cargosLocales || "No");
  setDODA(data.DODA || "No");
  setBoleta(data.boleta || "No");
  setPrealta(data.prealta || "No");
  setEIR(data.EIR || "No");
  setBLRevalidado(data.BLRevalidado || "No");
  setDemorasCartas(data.demorasCartas || "No");
  setValidacion(data.validacion || "No");
  setGarantia(data.garantia || "No");
  setTransporte(data.transporte || "No");
  setManiobras(data.maniobras || "No");
  setFechaManiobras(data.fechaManiobras || "");

  setDocumentos(data.documentos || "No");
  setTelex(data.telex || "No");
  setToquePiso(data.toquePiso || "No");
  setRevalidacion(data.revalidacion || "No");
  setPagoPedimento(data.pagoPedimento || "No");
  setRetornoVacio(data.retornoVacio || "No");
  setSalidaPuerto(data.salidaPuerto || "No");
  setSalidaRuta(data.salidaRuta || "No");
  setEntregaCliente(data.entregaCliente || "No");

  toggleStatus();
}
  function updateStatus(property, value, nombreFecha, fechaS, nomObservaciones, observaciones) {
    if (fechaS == '' || fechaS == undefined) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'La fecha no puede estar vacia',
      });
    } else {
      const data = {
        [property]: value,
        [nombreFecha]: fechaS,
        [nomObservaciones]: observaciones,
        statusSeguimiento,
      };

      axios
        .patch(`${URL_CONTENEDORES}/${id}`, data, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
          },
        })
        .then(() => {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Actualizado con Exito',
            showConfirmButton: false,
            timer: 2000,
          });

          let temp = comments.map((a) => {
            if (a._id === id) {
              a[nomObservaciones] = observaciones;
              a[nombreFecha] = fechaS;
              a[property] = value;
              a.statusSeguimiento = statusSeguimiento;
            }
            return a;
          });
          setComments(temp);

          // setTimeout(() => {
          //   setModalStatus(false);
          // }, 1000);
        })
        .catch((error) => {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong!',
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    }
  }

  function updateOnlyStatus() {
    axios
      .patch(
        `${URL_CONTENEDORES}/${id}`,
        {
          statusSeguimiento,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
          },
        }
      )
      .then(() => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Actualizado con Exito',
          showConfirmButton: false,
          timer: 2000,
        });

        let temp = comments.map((a) => {
          if (a._id === id) {
            a.statusSeguimiento = statusSeguimiento;
          }
          return a;
        });
        setComments(temp);

        setTimeout(() => {
          setModalStatus(false);
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }


      function jalaArchivos(id, packing, bl, invoice, fichaTecnicaArchivo, cargosLocales, DODA, boleta, prealta, EIR, BLRevalidado, demorasCartas, validacion, garantia, transporte) {
      setIdContenedor(id);
      setPacking(packing);
      setBlArchivo(bl);
      setInvoice(invoice);
      setFichaTecnicaArchivo(fichaTecnicaArchivo);
      setCargosLocales(cargosLocales);
      setDODA(DODA);
      setBoleta(boleta);
      setPrealta(prealta);
      setEIR(EIR);
      setBLRevalidado(BLRevalidado);
      setDemorasCartas(demorasCartas);
      setValidacion(validacion);
      setGarantia(garantia);
      setTransporte(transporte);
      toggleFotos();
    }

  return (
    <>
      <Header />
      {user.menuContenedores ? (
        <div className={`card container col-sm-11${tablaCompacta ? " tabla-compacta" : ""}`}>
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <span className="page-title-icon"><i className="fas fa-ship" /></span>
                {t("Contenedores")}
              </h3>
              <p className="page-subtitle">{t("Seguimiento de contenedores marítimos")}</p>
            </div>
            <div className="page-actions">
              {user.contenedoresCreate ? (
                <Button
                  size="sm"
                  type="submit"
                  color="success"
                  href="/ContenedoresCreate"
                >
                  <i className="fas fa-plus" /> {t("Nuevo")}
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  color="success"
                  disabled
                >
                  <i className="fas fa-plus" /> {t("Nuevo")}
                </Button>
              )}
              <Button
                size="sm"
                href="/MenuContenedores"
                color="secondary"
                id="botonListado"
              >
                <i className="fas fa-arrow-left" /> {t("Regresar")}
              </Button>
              <ButtonGroup id="logoutBoton">
                {/* <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={
                    e=>{
                      axios
                      .get(`${URL_ARTICULOS_CONTENEDOR}Desarrollo`, {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                        },
                      })
                      .then((response) => {
                        alert(response.data)
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                    }
                  }
                >
                  Desarrollo <i class="far fa-file-pdf"></i>
                </Button> */}
                <Button
                  size="sm"
                  color="danger"
                  onClick={PDFTabla}
                >
                  <i className="far fa-file-pdf" /> PDF
                </Button>
                <Button
                  size="sm"
                  onClick={toggleMail}
                  color="info"
                >
                  <i className="fas fa-envelope" /> eMail
                </Button>
                <Button
                  size="sm"
                  color="primary"
                  onClick={excel}
                >
                  <i className="far fa-file-excel" /> Excel
                </Button>


                <Button
                  size="sm"
                  color="warning"
                  onClick={toggleFlete}
                >
                  <i className="fas fa-file-upload" /> Fletes
                </Button>
              </ButtonGroup>
            </div>
          </div>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>{t("Enviar Listado Contenedores")}</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="info" onClick={enviaMail}>
                <i className="fas fa-paper-plane" /> {t("Enviar")}
              </Button>
            </ModalFooter>
            </Modal>

            <Modal size="sm" isOpen={modalFlete} toggle={toggleFlete}>
            <ModalHeader toggle={toggleFlete}>
              <h4>{t("Cargar Fletes")}</h4>
            </ModalHeader>
            <ModalBody>
              {/* <Label className="mr-sm-2">Cargar Fletes</Label> */}
               <Row>

            <Col>
                    <Input
                      required
                      type="file"
                      name="file"
                      id="file"
                      onChange={(event) =>
                        importarArchivo(event)
                      }
                    />
                    </Col>
            </Row>
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={guardaFlete}>
                <i className="fas fa-save" /> {t("Guardar")}
              </Button>
            </ModalFooter>
          </Modal>
          <div className="filter-bar">
            <div>
              <Label className="mr-sm-2">{t("Fecha Inicio")}</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </div>
            <div>
              <Label className="mr-sm-2">{t("Fecha Fin")}</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </div>
            {/* <Col md={2}>
              <Label className="mr-sm-2">{t("Previo")}</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedPrevio}
                onChange={(e) => {
                  setSelectedPrevio(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">{t("Selecciona")}</option>
                <option value="Si">{t("Si")}</option>
                <option value="No">{t("No")}</option>
              </Input>
            </Col> */}
          </div>
          <div className="stats-row">
            <div className="stat-chip"><i className="fas fa-ship" style={{ color: "#2563eb" }} /> {t("Contenedores")} <span>{new Intl.NumberFormat("en-US").format(totalItems)}</span></div>
            <div className="stat-chip"><i className="fas fa-file-alt" style={{ color: "#64748b" }} /> {t("En esta página")} <span>{commentsData.length}</span></div>
          </div>
          <div className="table-toolbar">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
            <Search
              onSearch={(value) => {
                const searchTerms = value.split(',').map(term => term.trim());
                setSearch(searchTerms);
                setCurrentPage(1);
              }}
            />
          </div>
          <div className="table-wrapper" onScroll={scrollTabla}>
          <Table size="sm" hover className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr className="filter-row">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
              <Input
                  bsSize="sm"
                  type="select"
                  value={selectedNaviera}
                  onChange={(e) => {
                    setSelectedNaviera(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">{t("Selecciona")}</option>
                  {navieras
                    .sort((a, b) =>
                      a.name > b.name ? 1 : -1
                    )
                    .map((a) => {
                      return (
                        <option value={a._id}>{a.name}</option>
                      );
                    })}
                </Input>
              </td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedPuertoDestino}
                  onChange={(e) => {
                    setSelectedPuertoDestino(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">{t("Selecciona")}</option>
                  {puertosDestino.map((p) => (
                    <option key={p} value={p}>{p}</option>
                  ))}
                </Input>
              </td>
              <td></td>

              {user.tipo == "Cliente" ? (
                <td></td>
              ) : (
                <td style={{ paddingTop: "0px" }}>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={selectedCliente}
                    onChange={(e) => {
                      setSelectedCliente(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">{t("Selecciona")}</option>
                    {clientes
                      .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                      .map((a) => {
                        if (user.tipo == "Cliente") {
                          if (a._id == user.clientes) {
                            return <option value={a._id}>{a.nombre_comercial}</option>;
                          }
                        } else {
                          return <option value={a._id}>{a.nombre_comercial}</option>;
                        }
                      })}
                  </Input>
                </td>
           )} 

              {user.tipo == "Broker" ? (
                <td></td>
              ) : (
                <td style={{ paddingTop: "0px" }}>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={selectedBroker}
                    onChange={(e) => {
                      setSelectedBroker(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">{t("Selecciona")}</option>
                    {brokers
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        return <option value={a._id}>{a.name}</option>;
                      })}
                  </Input>
                </td>
              )}

              {user.tipo == "Forwarder" ? (
                <td></td>
              ) : (
                <td style={{ paddingTop: "0px" }}>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={selectedForwarder}
                    onChange={(e) => {
                      setSelectedForwarder(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">{t("Selecciona")}</option>
                    {forwarders
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        if (user.tipo == "Forwarder") {
                          if (a._id == user.forwarders) {
                            return <option value={a._id}>{a.name}</option>;
                          }
                        } else {
                          return <option value={a._id}>{a.name}</option>;
                        }
                      })}
                  </Input>
                </td>
              )}

              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedSurtido}
                  onChange={(e) => {
                    setSelectedSurtido(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">{t("Selecciona")}</option>
                  <option value="Si">{t("Si")}</option>
                  <option value="No">{t("No")}</option>
                </Input>
              </td>
              
                                        <td style={{ paddingTop: '0px' }}>
                <Input
                  type='select'
                  bsSize='sm'
                  value={selectedStatus}
                  onChange={(e) => {
                    setSelectedStatus(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                   <option value=''>Selecciona</option>
                  <option value='Pendiente'>Pendiente</option>
                  <option value='Envío de Documentos'>Envío de Documentos</option>
                  <option value='Naviera Freno Demoras'>Naviera Freno Demoras</option>
                  <option value='Cambio de CNEE'>Cambio de CNEE</option>
                  <option value="Bloqueado por revision de Aduana">Bloqueado por revision de Aduana</option>
                  <option value="Retenido desde Llegada">Retenido desde Llegada</option>
                  <option value='Cambio Patente'>Cambio Patente</option>
                  <option value='Revalidacion'>En Revalidacion</option>
                  <option value='Revalidado'>Revalidado</option>
                  <option value='En Pago de Pedimento'>En Pago de Pedimento</option>
                  <option value='Pedimento Pagado'>Pedimento Pagado</option>
                  <option value='Maniobras Agencia'>Maniobras Agencia</option>
                  <option value='Por Documentar Tren (Ferro)'>Por Documentar Tren (Ferro)</option>
                  <option value='Por Subir Tren (Ferro)'>Por Subir Tren (Ferro)</option>
                  <option value='Cita'>Cita</option>
                  <option value='Modulado'>Modulado</option>
                  <option value='Desaduanado'>Desaduanado</option>
                  <option value='Patio Recinto / Terminal'>Patio Recinto / Terminal</option>
                  <option value='Patio Transportista'>Patio Transportista</option>
                  <option value='PAMA'>PAMA</option>
                  <option value='Reconocimiento Aduanero'>Reconocimiento Aduanero</option>
                  <option value='OVMT'>OVMT</option>
                  <option value='Abandono'>Abandono</option>
                  <option value='RETENIDO DESDE LLEGADA'>RETENIDO DESDE LLEGADA</option>
                  <option value='En Tren'>En Tren</option>
                  <option value='En Ruta'>En Ruta</option>
                  <option value='Entregado'>Entregado</option>
                  <option value='Solicitud Internacion'>Solicitud Internacion</option>
                  <option value='Retorno Vacio'>Retorno Vacio</option>
                  <option value='Solicitud EIR'>Solicitud EIR</option>
                  <option value='Documentos Completos'>Documentos Completos</option>
                  <option value='Despachado'>Despachado</option>
                  <option value='Cancelado'>Cancelado</option>
                  <option value="Accidentado">Accidentado</option>
                  <option value="Robado">Robado</option>
                </Input>
              </td>
                <td style={{ paddingTop: '0px' }}>
                <Input
                  type='select'
                  bsSize='sm'
                  value={selectedEtapa}
                  onChange={(e) => {
                    setSelectedEtapa(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">{t("Selecciona")}</option>
                  {ETAPAS_VIAJE.map((et) => (
                    <option key={et} value={et}>{et}</option>
                  ))}
                  <option value="Sin rastreo">{t("Sin rastreo")}</option>

                </Input>
              </td>
              <td></td>
              <td>
                           <Input
                             bsSize="sm"
                             type="select"
                             value={selectedPrioridad}
                             onChange={(e) => {
                               const value = e.target.value === "" ? "" : Number(e.target.value); // Convertir a número si no está vacío
                               setSelectedPrioridad(value);
                               setCurrentPage(1);
                             }}
                           >
                             <option value="">{t("Selecciona")}</option>
                             <option value="0">{t("0")}</option>
                             <option value="1">{t("1")}</option>
                             <option value="2">{t("2")}</option>
                             <option value="3">{t("3")}</option>
                             <option value="4">{t("4")}</option>
                             <option value="5">{t("5")}</option>
                           </Input>
                           </td>
              <td></td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
              <Input
                bsSize="sm"
                type="select"
                value={selectedPrevio}
                onChange={(e) => {
                  setSelectedPrevio(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">{t("Selecciona")}</option>
                <option value="Si">{t("Si")}</option>
                <option value="No">{t("No")}</option>
              </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
              <Input
                bsSize="sm"
                type="select"
                value={selectedPL}
                onChange={(e) => {
                  setSelectedPL(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">{t("Selecciona")}</option>
                <option value="Si">{t("Si")}</option>
                <option value="No">{t("No")}</option>
              </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
              <Input
                bsSize="sm"
                type="select"
                value={selectedBL}
                onChange={(e) => {
                  setSelectedBL(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">{t("Selecciona")}</option>
                <option value="Si">{t("Si")}</option>
                <option value="No">{t("No")}</option>
              </Input>
              </td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
              <Input
                bsSize="sm"
                type="select"
                value={selectedActivo}
                onChange={(e) => {
                  setSelectedActivo(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">{t("Selecciona")}</option>
                <option value="Si">{t("Si")}</option>
                <option value="No">{t("No")}</option>
              </Input>
              </td>
            </tr>
            <tbody>
              {commentsData.map((a) => {
                if (a.activo == "No") {
                  return (
                    <tr style={{ backgroundColor: "#ed8c8c" }}>
                      <td className="td-strong">{a.numero}</td>
                      <td>{a.fecha}</td>
                      <td className="td-strong">{a.numeroReferencia}</td>
                      <td className="td-strong">{a.referencia}</td>
                      <td>{a.naviera}</td>
                      <td>{!sinFecha(a.buque) ? a.buque : !sinFecha(a.vessel) ? a.vessel : <span className="td-muted">—</span>}</td>
                      <td>{a.puertoDestino}</td>
                      <td>{(a.transbordos || []).length ? a.transbordos.map((x) => x.puerto).join(", ") : <span className="td-muted">—</span>}</td>
                      <td>{a.clientes}</td>
                      <td>{a.brokers}</td>
                      <td>{a.forwarders}</td>
                      <td>{a.etd}</td>
                      <td>{a.etaEstimada}</td>
                      <td>{a.etaReal}</td>
                      <td className="td-num">
                        {new Intl.NumberFormat("en-US").format(a.totalCantidad)}
                      </td>
                      <td className="td-num td-money">
                        {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.flete)}
                      </td>
                      <td></td>
                      {/* <td>
                        {new Intl.NumberFormat("en-US").format(
                          a.totalSurtido
                        )}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(
                          a.pendienteSurtir
                        )}
                      </td>
                      <td>
                        {"$" +
                          new Intl.NumberFormat("en-US").format(
                            a.totalGeneral
                          )}{" "}
                      </td> */}
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td><span className="badge-soft badge-soft-danger">CANCELADO</span></td>
                      <td></td>
                      <td></td>
                    </tr>
                  );
                } else {
                  return (
                    <tr>
                      <td className="td-strong">{a.numero}</td>
                      <td>{a.fecha}</td>
                      <td className="td-strong">{a.numeroReferencia}</td>
                      <td className="td-strong">{a.referencia}</td>
                      <td>{a.naviera}</td>
                      <td>{!sinFecha(a.buque) ? a.buque : !sinFecha(a.vessel) ? a.vessel : <span className="td-muted">—</span>}</td>
                      <td>{a.puertoDestino}</td>
                      <td>{(a.transbordos || []).length ? a.transbordos.map((x) => x.puerto).join(", ") : <span className="td-muted">—</span>}</td>
                      <td>{a.clientes}</td>
                      <td>{a.brokers}</td>
                      <td>{a.forwarders}</td>
                      <td>{a.etd}</td>
                      <td>{a.etaEstimada}</td>
                      <td>{a.etaReal}</td>
                      <td className="td-num">
                        {new Intl.NumberFormat("en-US").format(a.totalCantidad)}
                      </td>
                      <td className="td-num td-money">
                        {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.flete)}
                      </td>
                      <td>{a.incrementable}</td>
                      {/* <td>
                        {new Intl.NumberFormat("en-US").format(
                          a.totalSurtido
                        )}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(
                          a.pendienteSurtir
                        )}
                      </td>
                      <td>
                        {"$" +
                          new Intl.NumberFormat("en-US").format(
                            a.totalGeneral
                          )}{" "}
                      </td> 
                      <td>
                        <>
                          {a.enMar}{" "}
                          {a.enMar == "No" ? (
                            <Button
                              color="primary"
                              onClick={(e) => {
                                marcar(a._id);
                              }}
                              size="sm"
                            >
                              <i class="far fa-check-circle"></i>
                            </Button>
                          ) : (
                            <Button
                              color="danger"
                              onClick={(e) => {
                                desMarcar(a._id);
                              }}
                              size="sm"
                            >
                              <i class="far fa-times-circle"></i>
                            </Button>
                          )}
                        </>
                      </td>*/}
                      <td><span className={`badge-soft badge-soft-${a.surtido === "Si" ? "success" : "warning"}`}>{a.surtido}</span></td>
                      <td>{a.statusSeguimiento ? <span className={`badge-soft badge-soft-${badgeStatusSeguimiento(a.statusSeguimiento)}`}>{a.statusSeguimiento}</span> : null}</td>
                      <td>{a.etapaViaje ? <span className={`badge-soft badge-soft-${a.etapaViaje === "Arribó" ? "success" : a.etapaViaje === "Zarpó" || a.etapaViaje === "Transbordo" ? "info" : "secondary"}`}>{a.etapaViaje}</span> : <span className="td-muted">{a.rastreo === "Si" ? "—" : t("Sin rastreo")}</span>}</td>
                      <td className={sinFecha(a.fechaEntregaReal) ? "td-muted" : ""}>{muestraFecha(a.fechaEntregaReal) || "—"}</td>
                      <td className="td-num">{a.prioridad}</td>
                      {user.tipo != "Broker" ? (
                        <>
                          <td>
                            <>
                              <Button
                                size="sm"
                                color="danger"
                                title={t("Detalle de piezas (PDF)")}
                                onClick={(e) =>
                                  PDFOC(
                                    a.fecha,
                                    a.clientes,
                                    a.brokers,
                                    a.forwarders,
                                    a.totalCantidad,
                                    a.totalGeneral,
                                    a.observaciones,
                                    a.numero,
                                    a.naviera,
                                    a._id
                                  )
                                }
                              >
                                <i className="far fa-file-pdf"></i>
                              </Button>

                              {a.rastreo == 'No' && a.idNaviera != "65a093c4b196000019bbeca4" ? (
                      <Button
                      size='sm'
                        color='success'
                        title={t("Registrar rastreo en ShipsGo")}
                        onClick={(e) =>{
                          registrarSG(a._id, a.idNaviera, a.contenedor)
                        }
                        }
                      >
                        <i className="fas fa-satellite-dish" /> SG
                      </Button>
                      ):(
                        <Button
                          size='sm'
                        color='success'
                          title={t("Registrar rastreo en ShipsGo")}
                          disabled
                          >
                            <i className="fas fa-satellite-dish" /> SG
                          </Button>)}
                      <Button size="sm" color="info" title={t("Rastreo, checklist e historial")} onClick={() => setRastreoId(a._id)}>
                        <i className="fas fa-route" />
                      </Button>
                      {a.mapa !== 'No' ? (
                      // <Button
                      // size='sm'
                      //   onClick={(e) =>{
                      //     crearMapa(a.polLatitude,
                      //       a.polLongitude,
                      //       a.podLatitude,
                      //       a.podLongitude,
                      //       a.vesselLatitude,
                      //       a.vesselLongitude,
                      //       a.etaReal
                      //     )
                      //   }
                      //   }
                      // >
                      //   <i class='fas fa-map'></i>
                      // </Button>

<a href={a.mapa} target="_blank" rel="noopener noreferrer">
<Button size="sm" color="primary" title={t("Ver mapa")}>
  <i className="fas fa-map-marked-alt"></i>
</Button>
</a>
                      ):(
                        <Button
                          size='sm'
                          color="primary"
                          title={t("Ver mapa")}
                          disabled
                          >
                            <i className='fas fa-map-marked-alt'></i>
                          </Button>)}

                            </>
                          </td>
                          <td>
                             <td>
                      <Button
                        size='sm'
                        color="primary"
                        title={t("Archivos")}
                        onClick={(e) =>
                          jalaArchivos(
                            a._id,
                            a.packing,
                            a.bl,
                            a.invoice,
                            a.fichaTecnicaArchivo,
                            a.cargosLocales,
                            a.DODA,
                            a.boleta,
                            a.prealta,
                            a.EIR,
                            a.BLRevalidado,
                            a.demorasCartas,
                            a.validacion,
                            a.garantia,
                            a.transporte
                          )
                        }
                      >
                        <i className='fas fa-paperclip'></i>
                        </Button>
                                              <Button
                        color='warning'
                        id='Editar'
                        size='sm'
                        title={t("Seguimiento")}
onClick={(e) =>
  EditStatus({
    id: a._id,

    statusSeguimiento: a.statusSeguimiento,

    mar: a.mar,
    fechaMar: a.fechaMar,
    observacionesMar: a.observacionesMar,

    piso: a.piso,
    fechaPiso: a.fechaPiso,
    observacionesPiso: a.observacionesPiso,

    revision: a.revision,
    fechaRevision: a.fechaRevision,
    observacionesRevision: a.observacionesRevision,

    fechaModulacion: a.fechaModulacion,
    observacionesModulacion: a.observacionesModulacion,

    libre: a.libre,
    fechaLibre: a.fechaLibre,
    observacionesLibre: a.observacionesLibre,

    bl: a.bl,
    fechaBl: a.fechaBl,

    pl: a.pl,
    fechaPl: a.fechaPl,

    facturado: a.facturado,
    fechaFactura: a.fechaFactura,

    fichaTecnicaArchivo: a.fichaTecnicaArchivo,
    fechaFichaTecnica: a.fechaFichaTecnica,

    fechaEntradaPuerto: a.fechaEntradaPuerto,
    fechaDocumentos: a.fechaDocumentos,
    fechaTelex: a.fechaTelex,
    fechaToquePiso: a.fechaToquePiso,
    fechaRevalidacion: a.fechaRevalidacion,
    fechaPagoPedimento: a.fechaPagoPedimento,
    fechaRetornoVacio: a.fechaRetornoVacio,
    fechaSalidaPuerto: a.fechaSalidaPuerto,
    fechaSalidaRuta: a.fechaSalidaRuta,
    fechaEntregaCliente: a.fechaEntregaCliente,

    cargosLocales: a.cargosLocales,
    DODA: a.DODA,
    boleta: a.boleta,
    prealta: a.prealta,
    EIR: a.EIR,
    BLRevalidado: a.BLRevalidado,
    demorasCartas: a.demorasCartas,
    validacion: a.validacion,
    garantia: a.garantia,
    transporte: a.transporte,
    maniobras: a.maniobras,
    fechaManiobras: a.fechaManiobras,

    documentos: a.documentos,
                            telex: a.telex,
                            toquePiso: a.toquePiso,
                            revalidacion: a.revalidacion,
                            fichaTecnica: a.fichaTecnica,
                            pagoPedimento: a.pagoPedimento,
                            modulacion: a.modulacion,
                            retornoVacio: a.retornoVacio,
                            salidaPuerto: a.salidaPuerto,
                            salidaRuta: a.salidaRuta,
                            // maniobras: a.maniobras,
                            entregaCliente: a.entregaCliente,
  })
}
                      >
                        <i className='fas fa-calendar-check'></i>
                      </Button>
                      </td>
                          </td>
                          <td>
                            <>
                              {a.previo == "Si" ? (
                                <>
                                {/* {a.previo} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  onClick={(e) => jalaFoto(a._id)}
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {a.previo} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  disabled
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  onClick={(e) => {
                                    setIdContenedor(a._id);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFoto();
                                  }}
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  disabled
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                          <td>
                            <>
                              {a.packing == "Si" ? (
                                <>
                                {/* {a.packing} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  onClick={(e) => jalaFotoPacking(a._id)}
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {a.packing} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  disabled
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  onClick={(e) => {
                                    setIdContenedor(a._id);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoPacking();
                                  }}
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  disabled
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                          <td>
                            <>
                              {a.bl == "Si" ? (
                                <>
                                {/* {a.bl} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  onClick={(e) => jalaFotoBL(a._id)}
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {a.bl} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  disabled
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  onClick={(e) => {
                                    setIdContenedor(a._id);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoBL();
                                  }}
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  disabled
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>


                          <td>
                              {user.contenedoresEdit ? (
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  title={t("Editar")}
                                  onClick={(e) =>
                                    jalaInfo(
                                      a.fecha,
                                      a.idClientes,
                                      a.idBrokers,
                                      a.idForwarders,
                                      a.totalCantidad,
                                      a.totalGeneral,
                                      a.observaciones,
                                      a.numero,
                                      a.numeroReferencia,
                                      a.referenciaExtra,
                                      a.flete,
                                      a.incrementable,
                                      a.liberadoPor,
                                      a.idNaviera,
                                      a.buque,
                                      a.puertoDestino,
                                      a.direccionEntrega,
                                      a.fechaEntrega,
                                      a.horarioEntrega,
                                      a.contactoEntrega,
                                      a.observacionesEntrega,
                                      a.prioridad,
                                      a.referencia,
                                      a.etd,
                                      a.etaEstimada,
                                      a.etaReal,
                                      a.fechaLlegada,
                                      a.fechaLiberacion,
                                      a.fechaEntregaEstimada,
                                      a.fechaEntregaReal,
                                      a.aduana,
                                      a.rastreo,
                                      a.surtido,
                                      a._id
                                    )
                                  }
                                >
                                  <i className="fas fa-edit"></i>
                                </Button>
                              ) : (
                               <Button
  color="info"
  id="Editar"
  size="sm"
  title={t("Editar")}
  disabled={user.tipo !== "Broker"}
  onClick={() => {
    if (user.tipo === "Broker") {
      jalaInfoBroker(
        a.fecha,
                                      a.idClientes,
                                      a.idBrokers,
                                      a.idForwarders,
                                      a.totalCantidad,
                                      a.totalGeneral,
                                      a.observaciones,
                                      a.numero,
                                      a.numeroReferencia,
                                      a.referenciaExtra,
                                      a.flete,
                                      a.incrementable,
                                      a.liberadoPor,
                                      a.idNaviera,
                                      a.buque,
                                      a.puertoDestino,
                                      a.direccionEntrega,
                                      a.fechaEntrega,
                                      a.horarioEntrega,
                                      a.contactoEntrega,
                                      a.observacionesEntrega,
                                      a.prioridad,
                                      a.referencia,
                                      a.etd,
                                      a.etaEstimada,
                                      a.etaReal,
                                      a.fechaLlegada,
                                      a.fechaLiberacion,
                                      a.fechaEntregaEstimada,
                                      a.fechaEntregaReal,
                                      a.aduana,
                                      a.rastreo,
                                      a.surtido,
                                      a._id
      ); // si es Broker
    } else {
      jalaInfo(
        a.fecha,
                                      a.idClientes,
                                      a.idBrokers,
                                      a.idForwarders,
                                      a.totalCantidad,
                                      a.totalGeneral,
                                      a.observaciones,
                                      a.numero,
                                      a.numeroReferencia,
                                      a.referenciaExtra,
                                      a.flete,
                                      a.incrementable,
                                      a.liberadoPor,
                                      a.idNaviera,
                                      a.buque,
                                      a.puertoDestino,
                                      a.direccionEntrega,
                                      a.fechaEntrega,
                                      a.horarioEntrega,
                                      a.contactoEntrega,
                                      a.observacionesEntrega,
                                      a.prioridad,
                                      a.referencia,
                                      a.etd,
                                      a.etaEstimada,
                                      a.etaReal,
                                      a.fechaLlegada,
                                      a.fechaLiberacion,
                                      a.fechaEntregaEstimada,
                                      a.fechaEntregaReal,
                                      a.aduana,
                                      a.rastreo,
                                      a.surtido,
                                      a._id
      );
    }
  }}
>
  <i className="fas fa-edit"></i>
</Button>

                              )}

                              <Button
                                color="primary"
                                id="Editar"
                                size="sm"
                                title={t("Artículos")}
                                onClick={(e) => EditArticulos(a._id, a.numero, a.idClientes, a.idBrokers, a.idNaviera)}
                              >
                                <i className="fas fa-cart-plus"></i>
                              </Button>
                          </td>




                          <td>
                            {a.surtido == "Si" ||
                            a.totalGasto > 0 ||
                            a.totalSurtido > 0 ||
                            !user.contenedoresCreate ? (
                              <Button
                                size="sm"
                                color="danger"
                                title={t("Cancelar contenedor")}
                                disabled
                              >
                                <i className="fas fa-ban"></i>
                              </Button>
                            ) : (
                              <Button
                                size="sm"
                                color="danger"
                                title={t("Cancelar contenedor")}
                                onClick={(e) => cancelarContenedor(a._id)}
                              >
                                <i className="fas fa-ban"></i>
                              </Button>
                            )}
                          </td>
                        </>
                      ) : (
                        <>
                          <td>
                            <>
                              <Button
                                size="sm"
                                color="danger"
                                title={t("Detalle de piezas (PDF)")}
                                disabled
                              >
                                <i className="far fa-file-pdf"></i>
                              </Button>
                             
                            </>
                          </td>
                          <td>
                            <>
                              {a.previo == "Si" ? (
                                <>
                                {/* {a.previo} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  onClick={(e) => jalaFoto(a._id)}
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {a.previo} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  disabled
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  onClick={(e) => {
                                    setIdContenedor(a._id);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFoto();
                                  }}
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  disabled
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                          <td>
                            <>
                              {a.packing == "Si" ? (
                                <>
                                {/* {a.packing} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  onClick={(e) => jalaFotoPacking(a._id)}
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {a.packing} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  disabled
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  onClick={(e) => {
                                    setIdContenedor(a._id);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoPacking();
                                  }}
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  disabled
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                          <td>
                            <>
                              {a.bl == "Si" ? (
                                <>
                                {/* {a.bl} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  onClick={(e) => jalaFotoBL(a._id)}
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {a.bl} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  disabled
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  onClick={(e) => {
                                    setIdContenedor(a._id);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoBL();
                                  }}
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  disabled
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                          <td>
                              {user.contenedoresEdit ? (
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  title={t("Editar")}
                                  onClick={(e) =>
                                    jalaInfo(
                                      a.fecha,
                                      a.idClientes,
                                      a.idBrokers,
                                      a.idForwarders,
                                      a.totalCantidad,
                                      a.totalGeneral,
                                      a.observaciones,
                                      a.numero,
                                      a.numeroReferencia,
                                      a.referenciaExtra,
                                      a.flete,
                                      a.incrementable,
                                      a.liberadoPor,
                                      a.idNaviera,
                                      a.buque,
                                      a.puertoDestino,
                                      a.direccionEntrega,
                                      a.fechaEntrega,
                                      a.horarioEntrega,
                                      a.contactoEntrega,
                                      a.observacionesEntrega,
                                      a.prioridad,
                                      a.referencia,
                                      a.etd,
                                      a.etaEstimada,
                                      a.etaReal,
                                      a.fechaLlegada,
                                      a.fechaLiberacion,
                                      a.fechaEntregaEstimada,
                                      a.fechaEntregaReal,
                                      a.aduana,
                                      a.rastreo,
                                      a.surtido,
                                      a._id
                                    )
                                  }
                                >
                                  <i className="fas fa-edit"></i>
                                </Button>
                              ) : (
                                                         <Button
  color="info"
  id="Editar"
  size="sm"
  title={t("Editar")}
  disabled={user.tipo !== "Broker"}
  onClick={() => {
    if (user.tipo === "Broker") {
      jalaInfoBroker(
        a.fecha,
                                      a.idClientes,
                                      a.idBrokers,
                                      a.idForwarders,
                                      a.totalCantidad,
                                      a.totalGeneral,
                                      a.observaciones,
                                      a.numero,
                                      a.numeroReferencia,
                                      a.referenciaExtra,
                                      a.flete,
                                      a.incrementable,
                                      a.liberadoPor,
                                      a.idNaviera,
                                      a.buque,
                                      a.puertoDestino,
                                      a.direccionEntrega,
                                      a.fechaEntrega,
                                      a.horarioEntrega,
                                      a.contactoEntrega,
                                      a.observacionesEntrega,
                                      a.prioridad,
                                      a.referencia,
                                      a.etd,
                                      a.etaEstimada,
                                      a.etaReal,
                                      a.fechaLlegada,
                                      a.fechaLiberacion,
                                      a.fechaEntregaEstimada,
                                      a.fechaEntregaReal,
                                      a.aduana,
                                      a.rastreo,
                                      a.surtido,
                                      a._id
      ); // si es Broker
    } else {
      jalaInfo(
        a.fecha,
                                      a.idClientes,
                                      a.idBrokers,
                                      a.idForwarders,
                                      a.totalCantidad,
                                      a.totalGeneral,
                                      a.observaciones,
                                      a.numero,
                                      a.numeroReferencia,
                                      a.referenciaExtra,
                                      a.flete,
                                      a.incrementable,
                                      a.liberadoPor,
                                      a.idNaviera,
                                      a.buque,
                                      a.puertoDestino,
                                      a.direccionEntrega,
                                      a.fechaEntrega,
                                      a.horarioEntrega,
                                      a.contactoEntrega,
                                      a.observacionesEntrega,
                                      a.prioridad,
                                      a.referencia,
                                      a.etd,
                                      a.etaEstimada,
                                      a.etaReal,
                                      a.fechaLlegada,
                                      a.fechaLiberacion,
                                      a.fechaEntregaEstimada,
                                      a.fechaEntregaReal,
                                      a.aduana,
                                      a.rastreo,
                                      a.surtido,
                                      a._id
      );
    }
  }}
>
  <i className="fas fa-edit"></i>
</Button>
                              )}

                              <Button
                                color="primary"
                                id="Editar"
                                size="sm"
                                title={t("Artículos")}
                                onClick={(e) => EditArticulos(a._id, a.numero, a.idClientes, a.idBrokers, a.idNaviera)}
                              >
                                <i className="fas fa-cart-plus"></i>
                              </Button>
                          </td>
                          <td>
                            {a.surtido == "Si" ||
                            a.totalGasto > 0 ||
                            a.totalSurtido > 0 ? (
                              <Button
                                size="sm"
                                color="danger"
                                title={t("Cancelar contenedor")}
                                disabled
                              >
                                <i className="fas fa-ban"></i>
                              </Button>
                            ) : (
                              <Button
                                size="sm"
                                color="danger"
                                title={t("Cancelar contenedor")}
                                disabled
                              >
                                <i className="fas fa-ban"></i>
                              </Button>
                            )}
                          </td>
                        </>
                      )}
                    </tr>
                  );
                }
              })}
            </tbody>
          </Table>
          </div>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <ContenedorRastreo
        isOpen={!!rastreoId}
        toggle={() => setRastreoId(null)}
        contenedorId={rastreoId}
      />

      <Modal size="xl" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>
            {t("Editar")} {t("Contenedor")} {numeroContenedor}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={3}>
              <Label>{t("Fecha")}</Label>
              <Input
                type="date"
                placeholder="Fecha"
                value={fecha}
                required
                onChange={(e) => {
                  setFecha(e.target.value);
                }}
              />
            </Col>

            <Col md={3}>
              <Label>{t("Numero de Referencia")}</Label>
              <Input
                type="text"
                placeholder="NumeroReferencia"
                value={numeroReferencia}
                required
                onChange={(e) => {
                  setNumeroReferencia(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>{t("Puerto de origen")}</Label>
              <PuertoSelect tipo="Origen" puertos={puertos} value={embarqueEdit.puerto} onChange={(v) => setEmbEdit("puerto", v)} />
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">{t("Contenedor")}</Label>
              <Input
                type="text"
                placeholder="Referencia"
                value={referencia}
                required
                onChange={(e) => {
                  setReferencia(e.target.value);
                }}
              />
            </Col>
            </Row>
            <br />
            <Row>
            <Col md={3}>
              <Label className="mr-sm-2">{t("Naviera")}</Label>
              { rastreo == "No" ? (
                 <Input
                 className="col-sm-12"
                 type="select"
                 value={selectedNavieraEdit}
                 required
                 onChange={(e) => {
                   setSelectedNavieraEdit(e.target.value);
                 }}
               >
                 <option value="0">{t("Selecciona")}</option>
                 {navieras
                   .sort((a, b) =>
                     a.name > b.name ? 1 : -1
                   )
                   .map((a) => {
                     return <option value={a._id}>{a.name}</option>;
                   })}
               </Input>
              ):(
                <Input
                className="col-sm-12"
                type="select"
                value={selectedNavieraEdit}
                required
                disabled
              >
                <option value="0">{t("Selecciona")}</option>
                {navieras
                  .sort((a, b) =>
                    a.name > b.name ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
              )}
              
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">{t("Cliente")}</Label>
              {surtido == "No" ? (
                <Input
                className="col-sm-12"
                type="select"
                value={selectedClienteEdit}
                required
                onChange={(e) => {
                  setSelectedClienteEdit(e.target.value);
                }}
              >
                <option value="0">{t("Selecciona")}</option>
                {clientes
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
              ):(
                <Input
                className="col-sm-12"
                type="select"
                value={selectedClienteEdit}
                required
                disabled
              >
                <option value="0">{t("Selecciona")}</option>
                {clientes
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
              )}
              
            </Col>

            <Col md={3}>
              <Label className="mr-sm-2">Broker</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedBrokerEdit}
                required
                onChange={(e) => {
                  setSelectedBrokerEdit(e.target.value);
                }}
              >
                <option value="0">{t("Selecciona")}</option>
                {brokers
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>

            <Col md={3}>
              <Label className="mr-sm-2">Forwarder</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedForwarderEdit}
                required
                onChange={(e) => {
                  setSelectedForwarderEdit(e.target.value);
                }}
              >
                <option value="0">{t("Selecciona")}</option>
                {forwarders
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label>ETD</Label>
              <Input
                type="date"
                placeholder="Fecha ETD"
                value={fechaETD}
                required
                onChange={(e) => {
                  setFechaETD(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>ETA {t("Puerto")}</Label>
              <Input
                type="date"
                value={fechaETAEstimada}
                required
                onChange={(e) => {
                  setFechaETAEstimada(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Arribo Real Puerto</Label>
              <Input
                type="date"
                value={fechaETAReal}
                required
                onChange={(e) => {
                  setFechaETAReal(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>{t("Liberacion Aduana")}</Label>
              <Input
                type="select"
                value={aduana}
                required
                onChange={(e) => {
                  setAduana(e.target.value);
                }}
              >
                <option value="No">No</option>
                <option value="Si">{t("Si")}</option>
              </Input>
            </Col>
          </Row>
          <br />
          <Row>
            {/* <Col md={3}>
                <Label>Fecha Liberacion</Label>
                <Input
                  type="date"
                  value={fechaLiberacion}
                  required
                  onChange={(e) => {
                    setFechaLiberacion(e.target.value);
                  }}
                />
              </Col> */}
            {/* <Col md={3}>
              <Label>{t("Fecha")} {t("Entrega")} {t("Estimada")}</Label>
                <Input
                  type="date"
                  value={fechaEntregaEstimada}
                  required
                  onChange={(e) => {
                    setFechaEntregaEstimada(e.target.value);
                  }}
                />
              </Col> */}
               <Col md={3}>
              <Label>{t("Buque")}</Label>
              <Input
                type="text"
                placeholder="buque"
                value={buque}
                required
                onChange={(e) => {
                  setBuque(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>
                {t("Fecha")} {t("Entrega")} Real
              </Label>
              <Input
                type="date"
                value={muestraFecha(fechaEntregaReal)}
                onChange={(e) => {
                  setFechaEntregaReal(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>{t("Flete")}</Label>
              <Input
                type="number"
                placeholder="Flete"
                value={flete}
                required
                onChange={(e) => {
                  setFlete(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
                <Label>{t("Incrementable")}</Label>
                <Input
                  type="select"
                  placeholder="Incrementable"
                  value={incrementable}
                  required
                  onChange={(e) => {
                    setIncrementable(e.target.value);
                  }}
                >
                 <option value="">{t("Selecciona")}</option>
                 <option value="Si">{t("Si")}</option>
                 <option value="No">{t("No")}</option>
                  
                </Input> 
              </Col>
          </Row>
          <br />
          <Row>
             <Col md={3}>
              <Label>{t("Puerto Destino")}</Label>
              <PuertoSelect tipo="Destino" puertos={puertos} value={puertoDestino} onChange={setPuertoDestino} />
            </Col>
          <Col md={3}>
              <Label>{t("Prioridad")}</Label>
              <Input
                type="number"
                placeholder="Prioridad"
                value={prioridad}
                required
                onChange={(e) => {
                  setPrioridad(e.target.value);
                }}
              />
            </Col>
            <Col md={6}>
              <Label for="exampleEmail" className="mr-sm-2">
                {t("Observaciones")}
              </Label>
              <Input
                type="text"
                placeholder="Observaciones"
                value={observaciones}
                required
                onChange={(e) => {
                  setObservaciones(e.target.value);
                }}
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label>{t("Direccion Entrega")}</Label>
              <Input
                type="text"
                placeholder="Direccion Entrega"
                value={direccionEntrega}
                required
                onChange={(e) => {
                  setDireccionEntrega(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>{t("Fecha Entrega")}</Label>
              <Input
                type="date"
                placeholder="Fecha Entrega"
                value={fechaEntrega}
                required
                onChange={(e) => {
                  setFechaEntrega(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>{t("Horario Entrega")}</Label>
              <Input
                type="text"
                placeholder="Horario Entrega"
                value={horarioEntrega}
                required
                onChange={(e) => {
                  setHorarioEntrega(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>{t("Contacto Entrega")}</Label>
              <Input
                type="text"
                placeholder="Contacto Entrega"
                value={contactoEntrega}
                required
                onChange={(e) => {
                  setContactoEntrega(e.target.value);
                }}
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={6}>
              <Label>{t("Observaciones Entrega")}</Label>
              <Input
                type="text"
                placeholder="Observaciones Entrega"
                value={observacionesEntrega}
                required
                onChange={(e) => {
                  setObservacionesEntrega(e.target.value);
                }}
              />
            </Col>
          </Row>
          <br />
          <Row>
            <CamposEmbarque valores={embarqueEdit} set={setEmbEdit} md={3} conBL />
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editContenedores}>
            <i className="fas fa-save" /> {t("Guardar")}
          </Button>
        </ModalFooter>
      </Modal>

            <Modal size="xl" isOpen={modalEditBroker} toggle={toggleEditBroker}>
        <ModalHeader toggle={toggleEditBroker}>
          <h4>
            {t("Editar")} {t("Contenedor")} {numeroContenedor}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={3}>
              <Label>{t("Direccion Entrega")}</Label>
              <Input
                type="text"
                placeholder="Direccion Entrega"
                value={direccionEntrega}
                required
                onChange={(e) => {
                  setDireccionEntrega(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>{t("Fecha Entrega")}</Label>
              <Input
                type="date"
                placeholder="Fecha Entrega"
                value={fechaEntrega}
                required
                onChange={(e) => {
                  setFechaEntrega(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>{t("Horario Entrega")}</Label>
              <Input
                type="text"
                placeholder="Horario Entrega"
                value={horarioEntrega}
                required
                onChange={(e) => {
                  setHorarioEntrega(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>{t("Contacto Entrega")}</Label>
              <Input
                type="text"
                placeholder="Contacto Entrega"
                value={contactoEntrega}
                required
                onChange={(e) => {
                  setContactoEntrega(e.target.value);
                }}
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={6}>
              <Label>{t("Observaciones Entrega")}</Label>
              <Input
                type="text"
                placeholder="Observaciones Entrega"
                value={observacionesEntrega}
                required
                onChange={(e) => {
                  setObservacionesEntrega(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>{t("Quién revalida")}</Label>
              <RevalidadorSelect value={embarqueEdit.quienRevalida} onChange={(v) => setEmbEdit("quienRevalida", v)} />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editContenedores}>
            <i className="fas fa-save" /> {t("Guardar")}
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        size="xxl"
        isOpen={modalEditArticulos}
        toggle={toggleEditArticulos}
      >
        <ModalHeader toggle={toggleEditArticulos}>
          <h4>
            {"Editar"} {t("Articulos")} {t("Contenedor")} {numeroContenedor}
          </h4>
          <h4>
            TOTAL {totalCantidad_edit} pzas. /{" "}
            {"$" + new Intl.NumberFormat("en-US").format(totalGeneral_edit)}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">{t("Articulos")}</Label>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">{t("Descripcion")}</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">{t("Proveedor")}</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">{t("Marca")}</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">{t("PO")}</Label>
            </Col>

            <Col md={1}>
              <Label className="mr-sm-2">{t("CBM")}</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">{t("Cantidad")}</Label>
            </Col>
            {/* <Col md={1}>
              <Label className="mr-sm-2">{t("Surtido")}</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">{t("Por Surtir")}</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">{t("Precio")}</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Total</Label>
            </Col> */}
          </Row>

          {articulosContenedor.map((ao) => (
            <div key={ao.id}>
              <Row>
                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="articulos"
                    type="select"
                    value={ao.articulos}
                    required
                    onChange={(event) => {
                      BuscaArticuloExistentes(ao.id, event);
                    }}
                  >
                    <option value="0">{t("Selecciona")}</option>
                    {articulos
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        return <option value={a._id}>{a.name}</option>;
                      })}
                  </Input>
                </Col>

                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="descripcion"
                    type="text"
                    placeholder="descripcion"
                    value={ao.descripcion}
                    required
                    onChange={(event) =>
                      handleChangeInputExistentes(ao.id, event)
                    }
                  />
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="proveedor"
                    type="text"
                    placeholder="proveedor"
                    value={ao.proveedor}
                    required
                    onChange={(event) =>
                      handleChangeInputExistentes(ao.id, event)
                    }
                  />
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="marca"
                    type="text"
                    placeholder="marca"
                    value={ao.marca}
                    required
                    onChange={(event) =>
                      handleChangeInputExistentes(ao.id, event)
                    }
                  />
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="PO"
                    type="number"
                    placeholder="PO"
                    value={ao.PO}
                    required
                    onChange={(event) =>
                      handleChangeInputExistentes(ao.id, event)
                    }
                  />
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="CBMS"
                    type="number"
                    placeholder="CBMS"
                    value={ao.CBMS}
                    required
                    onChange={(event) =>
                      handleChangeInputExistentes(ao.id, event)
                    }
                  />
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="cantidad"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Cantidad"
                    value={ao.cantidad}
                    required
                    onChange={(event) =>
                      handleChangeInputExistentesCantidad(ao.id, event)
                    }
                  />
                </Col>
                {/* <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="surtido"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="surtido"
                    value={ao.cantidadSurtido}
                    required
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="pendienteSurtir"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="pendienteSurtir"
                    value={ao.pendienteSurtir}
                    required
                    disabled
                  />
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="precio"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Precio"
                    value={ao.precio}
                    required
                    onChange={(event) =>
                      handleChangeInputExistentes(ao.id, event)
                    }
                  />
                </Col>
                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="total"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Total"
                    value={ao.total}
                    disabled
                    onChange={(event) =>
                      handleChangeInputExistentes(ao.id, event)
                    }
                  />
                </Col> */}
              </Row>
            </div>
          ))}

          {/* Agregar mas articulos */}

          {inputFields.map((inputField) => (
            <div key={inputField.id}>
              <Row>
                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="articulos"
                    type="select"
                    value={inputField.articulos}
                    required
                    onChange={(event) => {
                      BuscaArticulo(inputField.id, event);
                    }}
                  >
                    <option value="0">{t("Selecciona")}</option>
                    {articulos
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        return <option value={a._id}>{a.name}</option>;
                      })}
                  </Input>
                </Col>

                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="descripcion"
                    type="text"
                    placeholder="descripcion"
                    value={inputField.descripcion}
                    required
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="proveedor"
                    type="text"
                    placeholder="proveedor"
                    value={inputField.proveedor}
                    required
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="marca"
                    type="text"
                    placeholder="marca"
                    value={inputField.marca}
                    required
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="PO"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="PO"
                    value={inputField.PO}
                    required
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="CBMS"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="CBMS"
                    value={inputField.CBMS}
                    required
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="cantidad"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Cantidad"
                    value={inputField.cantidad}
                    required
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>
                {/* <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="surtido"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="NA"
                    value={inputField.cantidadSurtido}
                    required
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="pendienteSurtir"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="NA"
                    value={inputField.pendienteSurtir}
                    required
                    disabled
                  />
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="precio"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Precio"
                    value={inputField.precio}
                    required
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>

                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="total"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Total"
                    value={inputField.total}
                    disabled
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col> */}
                <Col>
                  <Button
                    size="sm"
                    color="danger"
                    title={t("Quitar renglón")}
                    disabled={inputFields.length === 1}
                    onClick={() => handleRemoveFields(inputField.id)}
                    tabindex="-1"
                  >
                    <i className="fas fa-minus"></i>
                  </Button>
                  <Button
                    size="sm"
                    color="success"
                    title={t("Agregar renglón")}
                    onClick={handleAddFields}
                    tabindex="-1"
                  >
                    <i className="fas fa-plus"></i>
                  </Button>
                </Col>
              </Row>
            </div>
          ))}
          <Row>
            <Col md={6}>
              <h4 id="logoutBoton">
                TOTAL {totalCantidad_edit} pzas. /{" "}
                {"$" + new Intl.NumberFormat("en-US").format(totalGeneral_edit)}
              </h4>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button size="sm" color="success" onClick={saveContenedor}>
            <i className="fas fa-save" /> {t("Guardar")}
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>{t("Progreso")}</h4>
        </ModalHeader>
        <ModalBody>
          <h4>
            {" "}
            {t("Este proceso puede tardar varios segundos.")}
            <br />
            {t("Por favor no cierre ni refresque su navegador.")}
          </h4>
          <br />
          <div className="progreso">
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
          </div>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalSubirFoto} toggle={toggleSubirFoto}>
        <ModalHeader toggle={toggleSubirFoto}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <Label>Selecciona un archivo</Label>
              <Input
                 type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
          </Row>
          <Button size="sm" color="success" onClick={guardaFotos}>
            <i className="fas fa-save" /> Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalSubirFotoPacking} toggle={toggleSubirFotoPacking}>
        <ModalHeader toggle={toggleSubirFotoPacking}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosPacking}>
            <i className="fas fa-save" /> Guardar
          </Button>
        </ModalBody>
      </Modal>
      <Modal size="sm" isOpen={modalSubirFotoBL} toggle={toggleSubirFotoBL}>
        <ModalHeader toggle={toggleSubirFotoBL}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosBL}>
            <i className="fas fa-save" /> Guardar
          </Button>
        </ModalBody>
      </Modal>

<Modal size="xxl" isOpen={modalFoto} toggle={toggleFoto}>
  <ModalHeader toggle={toggleFoto}>
    <h4>Fotos</h4>
  </ModalHeader>
  <ModalBody>
    <Row>
      {(photo || []).length > 0 ? (
        (photo || []).map((item) => (
          <div
            key={item.asset_id || item.id}
            style={{ textAlign: "center", marginBottom: "20px" }}
          >
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" ||
              item.format === "xlsx" ||
              item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  <i className="fas fa-download" /> Descargar {item.original_filename}.{item.format}
                </Button>
              </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}

            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                <i className="fas fa-trash-alt" /> Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
  </ModalBody>
</Modal>

    
<Modal size="xxl" isOpen={modalFotoPacking} toggle={toggleFotoPacking}>
  <ModalHeader toggle={toggleFotoPacking}>
    <h4>Packing List</h4>
  </ModalHeader>
  <ModalBody>
    <Row>
      {(photo || []).length > 0 ? (
        (photo || []).map((item) => (
          <div
            key={item.asset_id || item.id}
            style={{ textAlign: "center", marginBottom: "20px" }}
          >
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" ||
              item.format === "xlsx" ||
              item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  <i className="fas fa-download" /> Descargar {item.original_filename}.{item.format}
                </Button>
              </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}

            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                <i className="fas fa-trash-alt" /> Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
  </ModalBody>
</Modal>

<Modal size="xxl" isOpen={modalFotoBL} toggle={toggleFotoBL}>
  <ModalHeader toggle={toggleFotoBL}>
    <h4>BL</h4>
  </ModalHeader>
  <ModalBody>
    <Row>
      {(photo || []).length > 0 ? (
        (photo || []).map((item) => (
          <div
            key={item.asset_id || item.id}
            style={{ textAlign: "center", marginBottom: "20px" }}
          >
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" ||
              item.format === "xlsx" ||
              item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  <i className="fas fa-download" /> Descargar {item.original_filename}.{item.format}
                </Button>
              </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}

            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                <i className="fas fa-trash-alt" /> Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
  </ModalBody>
</Modal>


    
      <Modal size='xl' isOpen={modalMapa} toggle={toggleMapa}>
        <ModalHeader toggle={toggleMapa}>
          <h4>Trayectoria del Contenedor. Faltan {diasLlegada} dias para la llegada</h4>
          </ModalHeader>
      <ModalBody>
      <MapContainer 
          center={vesselCoords}  // Cambia el centro al océano Pacífico, lo que coloca Asia a la izquierda y América a la derecha
          zoom={3} 
          style={{ height: "400px", width: "100%" }}
          maxBounds={[[85, -180], [-85, 180]]}  // Limita el mapa a un único globo terráqueo
          maxBoundsViscosity={1.0}  // Impide que se salga de los límites
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            // attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            noWrap={true}  // Evita que el mapa se "envuelva"
          />

          {/* Marcadores para el origen, posición actual y destino */}
          <Marker position={destinationCoords}></Marker>
          <Marker position={vesselCoords}></Marker>
          <Marker position={originCoords}></Marker>

          {/* Línea de trayectoria */}
          {/* <Polyline positions={coordenadasMapa} color="blue" />
           */}
           <Polyline positions={[vesselCoords, destinationCoords]} color="blue" dashArray="5,10" />
        </MapContainer>
      </ModalBody>
      </Modal>

          <Modal size='lg' isOpen={modalStatus} toggle={toggleStatus}>
        <ModalHeader toggle={toggleStatus}>
          <h4>
            {t('Status')} Contenedor {numeroInterno}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Button size='sm' color='primary' onClick={excel}>
              <i className='far fa-file-excel'></i> Excel
            </Button>
          </Row>
          <Row>
            <Col md={4}>
              <Label>Status</Label>
              <Input
                type='select'
                value={statusSeguimiento}
                onChange={(e) => setStatusSeguimiento(e.target.value)}
              >
                  <option value=''>Selecciona</option>
                  <option value='Pendiente'>Pendiente</option>
                  <option value='Envío de Documentos'>Envío de Documentos</option>
                  <option value='Naviera Freno Demoras'>Naviera Freno Demoras</option>
                  <option value='Cambio de CNEE'>Cambio de CNEE</option>
                  <option value="Bloqueado por revision de Aduana">Bloqueado por revision de Aduana</option>
                  <option value="Retenido desde Llegada">Retenido desde Llegada</option>
                  <option value='Cambio Patente'>Cambio Patente</option>
                  <option value='Revalidacion'>En Revalidacion</option>
                  <option value='Revalidado'>Revalidado</option>
                  <option value='En Pago de Pedimento'>En Pago de Pedimento</option>
                  <option value='Pedimento Pagado'>Pedimento Pagado</option>
                  <option value='Maniobras Agencia'>Maniobras Agencia</option>
                  <option value='Por Documentar Tren (Ferro)'>Por Documentar Tren (Ferro)</option>
                  <option value='Por Subir Tren (Ferro)'>Por Subir Tren (Ferro)</option>
                  <option value='Cita'>Cita</option>
                  <option value='Modulado'>Modulado</option>
                  <option value='Desaduanado'>Desaduanado</option>
                  <option value='Patio Recinto / Terminal'>Patio Recinto / Terminal</option>
                  <option value='Patio Transportista'>Patio Transportista</option>
                  <option value='PAMA'>PAMA</option>
                  <option value='Reconocimiento Aduanero'>Reconocimiento Aduanero</option>
                  <option value='OVMT'>OVMT</option>
                  <option value='Abandono'>Abandono</option>
                  <option value='RETENIDO DESDE LLEGADA'>RETENIDO DESDE LLEGADA</option>
                  <option value='En Tren'>En Tren</option>
                  <option value='En Ruta'>En Ruta</option>
                  <option value='Entregado'>Entregado</option>
                  <option value='Solicitud Internacion'>Solicitud Internacion</option>
                  <option value='Retorno Vacio'>Retorno Vacio</option>
                  <option value='Solicitud EIR'>Solicitud EIR</option>
                  <option value='Documentos Completos'>Documentos Completos</option>
                  <option value='Despachado'>Despachado</option>
                  <option value='Cancelado'>Cancelado</option>
                  <option value="Accidentado">Accidentado</option>
                  <option value="Robado">Robado</option>
              </Input>
              {/* </Col>
                <Col md={3}>
                  <Label>.</Label> */}
              <Button color='success' onClick={() => updateOnlyStatus()} size='sm'>
                <i className='fas fa-save'></i> Actualizar
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3} className='negrita'>
              <Label className='mr-sm-2'>Concepto</Label>
            </Col>
            <Col md={3} className='negrita'>
              <Label className='mr-sm-2'>Fecha</Label>
            </Col>
            <Col md={3} className='negrita'>
              <Label className='mr-sm-2'>Realizado</Label>
            </Col>
          </Row>

          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>BL</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaBl}
                onChange={(e) => setFechaBl(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <span className={`badge-soft badge-soft-${bl === 'Si' ? 'success' : 'warning'}`}>{bl === 'Si' ? 'Listo' : 'Pendiente'}</span>
            </Col>

            <Col md={3}>
              <Button
                color={bl === 'Si' ? 'success' : 'danger'}
                title={bl === 'Si' ? t('Marcar como pendiente') : t('Marcar como listo')}
                onClick={() =>
                  updateStatus(
                    'bl',
                    bl === 'Si' ? 'No' : 'Si',
                    'fechaBl',
                    fechaBl
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Packing List</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaPl}
                onChange={(e) => setFechaPl(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <span className={`badge-soft badge-soft-${pl === 'Si' ? 'success' : 'warning'}`}>{pl === 'Si' ? 'Listo' : 'Pendiente'}</span>
            </Col>

            <Col md={3}>
              <Button
                color={pl === 'Si' ? 'success' : 'danger'}
                title={pl === 'Si' ? t('Marcar como pendiente') : t('Marcar como listo')}
                onClick={() =>
                  updateStatus(
                    'pl',
                    pl === 'Si' ? 'No' : 'Si',
                    'fechaPl',
                    fechaPl
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Factura</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaFactura}
                onChange={(e) => setFechaFactura(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <span className={`badge-soft badge-soft-${facturado === 'Si' ? 'success' : 'warning'}`}>{facturado === 'Si' ? 'Listo' : 'Pendiente'}</span>
            </Col>

            <Col md={3}>
              <Button
                color={facturado === 'Si' ? 'success' : 'danger'}
                title={facturado === 'Si' ? t('Marcar como pendiente') : t('Marcar como listo')}
                onClick={() =>
                  updateStatus(
                    'facturado',
                    facturado === 'Si' ? 'No' : 'Si',
                    'fechaFactura',
                    fechaFactura
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>FichaTecnica</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaFichaTecnica}
                onChange={(e) => setFechaFichaTecnica(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <span className={`badge-soft badge-soft-${fichaTecnicaArchivo === 'Si' ? 'success' : 'warning'}`}>{fichaTecnicaArchivo === 'Si' ? 'Listo' : 'Pendiente'}</span>
            </Col>

            <Col md={3}>
              <Button
                color={fichaTecnicaArchivo === 'Si' ? 'success' : 'danger'}
                title={fichaTecnicaArchivo === 'Si' ? t('Marcar como pendiente') : t('Marcar como listo')}
                onClick={() =>
                  updateStatus(
                    'fichaTecnicaArchivo',
                    fichaTecnicaArchivo === 'Si' ? 'No' : 'Si',
                    'fechaFichaTecnica',
                    fechaFichaTecnica
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Telex</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaTelex}
                onChange={(e) => setFechaTelex(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <span className={`badge-soft badge-soft-${telex === 'Si' ? 'success' : 'warning'}`}>{telex === 'Si' ? 'Listo' : 'Pendiente'}</span>
            </Col>

            <Col md={3}>
              <Button
                color={telex === 'Si' ? 'success' : 'danger'}
                title={telex === 'Si' ? t('Marcar como pendiente') : t('Marcar como listo')}
                onClick={() =>
                  updateStatus(
                    'telex',
                    telex === 'Si' ? 'No' : 'Si',
                    'fechaTelex',
                    fechaTelex
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Toque de Piso</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaToquePiso}
                onChange={(e) => setFechaToquePiso(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <span className={`badge-soft badge-soft-${toquePiso === 'Si' ? 'success' : 'warning'}`}>{toquePiso === 'Si' ? 'Listo' : 'Pendiente'}</span>
            </Col>

            <Col md={3}>
              <Button
                color={toquePiso === 'Si' ? 'success' : 'danger'}
                title={toquePiso === 'Si' ? t('Marcar como pendiente') : t('Marcar como listo')}
                onClick={() =>
                  updateStatus(
                    'toquePiso',
                    toquePiso === 'Si' ? 'No' : 'Si',
                    'fechaToquePiso',
                    fechaToquePiso
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Revalidacion</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaRevalidacion}
                onChange={(e) => setFechaRevalidacion(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <span className={`badge-soft badge-soft-${revalidacion === 'Si' ? 'success' : 'warning'}`}>{revalidacion === 'Si' ? 'Listo' : 'Pendiente'}</span>
            </Col>

            <Col md={3}>
              <Button
                color={revalidacion === 'Si' ? 'success' : 'danger'}
                title={revalidacion === 'Si' ? t('Marcar como pendiente') : t('Marcar como listo')}
                onClick={() =>
                  updateStatus(
                    'revalidacion',
                    revalidacion === 'Si' ? 'No' : 'Si',
                    'fechaRevalidacion',
                    fechaRevalidacion
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Pedimento Pagado</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaPagoPedimento}
                onChange={(e) => setFechaPagoPedimento(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <span className={`badge-soft badge-soft-${pagoPedimento === 'Si' ? 'success' : 'warning'}`}>{pagoPedimento === 'Si' ? 'Listo' : 'Pendiente'}</span>
            </Col>

            <Col md={3}>
              <Button
                color={pagoPedimento === 'Si' ? 'success' : 'danger'}
                title={pagoPedimento === 'Si' ? t('Marcar como pendiente') : t('Marcar como listo')}
                onClick={() =>
                  updateStatus(
                    'pagoPedimento',
                    pagoPedimento === 'Si' ? 'No' : 'Si',
                    'fechaPagoPedimento',
                    fechaPagoPedimento
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          {/* <Row>
            <Col md={3}>
              <Label className="mr-sm-2">Documentos</Label>
            </Col>
            <Col md={3} className="negro">
              <Input
                type="date"
                value={fechaDocumentos}
                onChange={(e) => setfechaDocumentos(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <span className={`badge-soft badge-soft-${documentos === 'Si' ? 'success' : 'warning'}`}>{documentos === 'Si' ? 'Listo' : 'Pendiente'}</span>
            </Col>

            <Col md={3}>
              <Button
                color={documentos === 'Si' ? 'success' : 'danger'}
                title={documentos === 'Si' ? t('Marcar como pendiente') : t('Marcar como listo')}
                onClick={() =>
                  updateStatus(
                    "documentos",
                    documentos === "Si" ? "No" : "Si",
                    "fechaDocumentos",
                    fechaDocumentos
                  )
                }
                size="sm"
              >
                <i className="fas fa-check-circle"></i>
              </Button>
            </Col>
          </Row>
          <br /> */}
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Modulacion</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaModulacion}
                onChange={(e) => setFechaModulacion(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <span className={`badge-soft badge-soft-${modulacion === 'Si' ? 'success' : 'warning'}`}>{modulacion === 'Si' ? 'Listo' : 'Pendiente'}</span>
            </Col>

            <Col md={3}>
              <Button
                color={modulacion === 'Si' ? 'success' : 'danger'}
                title={modulacion === 'Si' ? t('Marcar como pendiente') : t('Marcar como listo')}
                onClick={() =>
                  updateStatus(
                    'modulacion',
                    modulacion === 'Si' ? 'No' : 'Si',
                    'fechaModulacion',
                    fechaModulacion
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />

          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Salida de Puerto</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaSalidaPuerto}
                onChange={(e) => setFechaSalidaPuerto(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <span className={`badge-soft badge-soft-${salidaPuerto === 'Si' ? 'success' : 'warning'}`}>{salidaPuerto === 'Si' ? 'Listo' : 'Pendiente'}</span>
            </Col>

            <Col md={3}>
              <Button
                color={salidaPuerto === 'Si' ? 'success' : 'danger'}
                title={salidaPuerto === 'Si' ? t('Marcar como pendiente') : t('Marcar como listo')}
                onClick={() =>
                  updateStatus(
                    'salidaPuerto',
                    salidaPuerto === 'Si' ? 'No' : 'Si',
                    'fechaSalidaPuerto',
                    fechaSalidaPuerto
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Salida Ruta</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaSalidaRuta}
                onChange={(e) => setFechaSalidaRuta(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <span className={`badge-soft badge-soft-${salidaRuta === 'Si' ? 'success' : 'warning'}`}>{salidaRuta === 'Si' ? 'Listo' : 'Pendiente'}</span>
            </Col>

            <Col md={3}>
              <Button
                color={salidaRuta === 'Si' ? 'success' : 'danger'}
                title={salidaRuta === 'Si' ? t('Marcar como pendiente') : t('Marcar como listo')}
                onClick={() =>
                  updateStatus(
                    'salidaRuta',
                    salidaRuta === 'Si' ? 'No' : 'Si',
                    'fechaSalidaRuta',
                    fechaSalidaRuta
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />

          {/* <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Maniobras</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaManiobras}
                onChange={(e) => setfechaManiobras(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <span className={`badge-soft badge-soft-${maniobras === 'Si' ? 'success' : 'warning'}`}>{maniobras === 'Si' ? 'Listo' : 'Pendiente'}</span>
            </Col>

            <Col md={3}>
              <Button
                color={maniobras === 'Si' ? 'success' : 'danger'}
                title={maniobras === 'Si' ? t('Marcar como pendiente') : t('Marcar como listo')}
                onClick={() =>
                  updateStatus(
                    'maniobras',
                    maniobras === 'Si' ? 'No' : 'Si',
                    'fechaManiobras',
                    fechaManiobras
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row> 
          <br />*/}

          {user.contenedoresEntrega?(
            <>
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Entrega Cliente</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaEntregaCliente}
                onChange={(e) => setFechaEntregaCliente(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <span className={`badge-soft badge-soft-${entregaCliente === 'Si' ? 'success' : 'warning'}`}>{entregaCliente === 'Si' ? 'Listo' : 'Pendiente'}</span>
            </Col>

            <Col md={3}>
              <Button
                color={entregaCliente === 'Si' ? 'success' : 'danger'}
                title={entregaCliente === 'Si' ? t('Marcar como pendiente') : t('Marcar como listo')}
                onClick={() =>
                  updateStatus(
                    'entregaCliente',
                    entregaCliente === 'Si' ? 'No' : 'Si',
                    'fechaEntregaCliente',
                    fechaEntregaCliente
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          </>
        ):undefined}
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Retorno Vacio</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaRetornoVacio}
                onChange={(e) => setFechaRetornoVacio(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <span className={`badge-soft badge-soft-${retornoVacio === 'Si' ? 'success' : 'warning'}`}>{retornoVacio === 'Si' ? 'Listo' : 'Pendiente'}</span>
            </Col>

            <Col md={3}>
              <Button
                color={retornoVacio === 'Si' ? 'success' : 'danger'}
                title={retornoVacio === 'Si' ? t('Marcar como pendiente') : t('Marcar como listo')}
                onClick={() =>
                  updateStatus(
                    'retornoVacio',
                    retornoVacio === 'Si' ? 'No' : 'Si',
                    'fechaRetornoVacio',
                    fechaRetornoVacio
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
        </ModalBody>
      </Modal>


    <Modal size="sm" isOpen={modalFotos} toggle={toggleFotos}>
      <ModalHeader toggle={toggleFotos}>
        <h4>Archivos</h4>
      </ModalHeader>
      <ModalBody>
        <Table size="sm" hover>
          <thead>
            <tr>
              <th>Titulo</th>
              <th>Archivos</th>
            </tr>
            </thead>
            <tbody>
{/*
<tr>
  <td className="td-strong">Packing</td>
  <td>
    <>
      {packing == "Si" ? (
        <>
          <Button
            color="primary"
            id="Editar"
            size="sm"
            title={t("Ver archivo")}
                                  onClick={(e) => jalaFotoPacking(idContenedor)}
          >
            <i className="fas fa-camera"></i>
          </Button>
        </>
      ) : (
        <>
          <Button
            color="primary"
            id="Editar"
            size="sm"
            title={t("Ver archivo")}
                                  disabled
          >
            <i className="fas fa-camera"></i>
          </Button>
        </>
      )}
      {user.contenedoresCreate ? (
        <Button
          color="success"
          id="Editar"
          size="sm"
          title={t("Subir archivo")}
                                  onClick={(e) => {
            setIdContenedor(idContenedor);
            toggleSubirFotoPacking();
          }}
        >
          <i className="fas fa-upload"></i>
        </Button>
      ) : (
        <Button
          color="success"
          id="Editar"
          size="sm"
          title={t("Subir archivo")}
                                  disabled
        >
          <i className="fas fa-upload"></i>
        </Button>
      )}
    </>
  </td>
</tr>
*/}
                <tr>
                  <td className="td-strong">Ficha Tecnica</td>
                  <td>
                            <>
                              {fichaTecnicaArchivo == "Si" ? (
                                <>
                                {/* {fichaTencnica} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  onClick={(e) => jalaFotoFichaTecnica(idContenedor)}
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {fichaTencnica} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  disabled
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoFichaTecnica();
                                  }}
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  disabled
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>
{/*
<tr>
  <td className="td-strong">BL</td>
  <td>
    <>
      {blArchivo == "Si" ? (
        <>
          <Button
            color="primary"
            id="Editar"
            size="sm"
            title={t("Ver archivo")}
                                  onClick={(e) => jalaFotoBL(idContenedor)}
          >
            <i className="fas fa-camera"></i>
          </Button>
        </>
      ) : (
        <>
          <Button
            color="primary"
            id="Editar"
            size="sm"
            title={t("Ver archivo")}
                                  disabled
          >
            <i className="fas fa-camera"></i>
          </Button>
        </>
      )}
      {user.contenedoresCreate ? (
        <Button
          color="success"
          id="Editar"
          size="sm"
          title={t("Subir archivo")}
                                  onClick={(e) => {
            setIdContenedor(idContenedor);
            toggleSubirFotoBL();
          }}
        >
          <i className="fas fa-upload"></i>
        </Button>
      ) : (
        <Button
          color="success"
          id="Editar"
          size="sm"
          title={t("Subir archivo")}
                                  disabled
        >
          <i className="fas fa-upload"></i>
        </Button>
      )}
    </>
  </td>
</tr>
*/}
                <tr>
                  <td className="td-strong">Invoice</td>
                  <td>
                            <>
                              {invoice == "Si" ? (
                                <>
                                {/* {invoice} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  onClick={(e) => jalaFotoInvoice(idContenedor)}
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {invoice} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  disabled
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoInvoice();
                                  }}
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  disabled
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>

                <tr>
                  <td className="td-strong">Cargos Locales</td>
                  <td>
                            <>
                              {cargosLocales == "Si" ? (
                                <>
                                {/* {cargosLocales} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  onClick={(e) => jalaFotoCargosLocales(idContenedor)}
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {cargosLocales} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  disabled
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoCargosLocales();
                                  }}
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  disabled
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>
                <tr>
                  <td className="td-strong">Garantia</td>
                  <td>
                            <>
                              {garantia == "Si" ? (
                                <>
                                {/* {garantia} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  onClick={(e) => jalaFotoGarantia(idContenedor)}
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {garantia} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  disabled
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoGarantia();
                                  }}
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  disabled
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>
                <tr>
                  <td className="td-strong">DODA</td>
                  <td>
                            <>
                              {DODA == "Si" ? (
                                <>
                                {/* {DODA} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  onClick={(e) => jalaFotoDODA(idContenedor)}
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {DODA} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  disabled
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoDODA();
                                  }}
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  disabled
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>
                <tr>
                  <td className="td-strong">Boleta</td>
                  <td>
                            <>
                              {boleta == "Si" ? (
                                <>
                                {/* {boleta} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  onClick={(e) => jalaFotoBoleta(idContenedor)}
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {boleta} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  disabled
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoBoleta();
                                  }}
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  disabled
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>
                <tr>
                  <td className="td-strong">Prealta</td>
                  <td>
                            <>
                              {prealta == "Si" ? (
                                <>
                                {/* {prealta} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  onClick={(e) => jalaFotoPrealta(idContenedor)}
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {prealta} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  disabled
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoPrealta();
                                  }}
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  disabled
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>
                <tr>
                  <td className="td-strong">EIR</td>
                  <td>
                            <>
                              {EIR == "Si" ? (
                                <>
                                {/* {EIR} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  onClick={(e) => jalaFotoEIR(idContenedor)}
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {EIR} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  disabled
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoEIR();
                                  }}
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  disabled
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>


                <tr>
                  <td className="td-strong">BL Revalidado</td>
                  <td>
                            <>
                              {BLRevalidado == "Si" ? (
                                <>
                                {/* {BLRevalidado} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  onClick={(e) => jalaFotoBLRevalidado(idContenedor)}
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {BLRevalidado} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  disabled
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoBLRevalidado();
                                  }}
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  disabled
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>

                </tr>

                <tr>
                  <td className="td-strong">Demoras y Cartas</td>
                  <td>
                            <>
                              {demorasCartas == "Si" ? (
                                <>
                                {/* {Demoras y Cartas} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  onClick={(e) => jalaFotoDemorasCartas(idContenedor)}
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {Demoras y Cartas} */}
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  title={t("Ver archivo")}
                                  disabled
                                >
                                  <i className="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoDemorasCartas();
                                  }}
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  title={t("Subir archivo")}
                                  disabled
                                >
                                  <i className="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>
            </tbody>
        </Table>
      </ModalBody>
    </Modal>


 <Modal size="sm" isOpen={modalSubirFotoPacking} toggle={toggleSubirFotoPacking}>
        <ModalHeader toggle={toggleSubirFotoPacking}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosPacking}>
            <i className="fas fa-save" /> Guardar
          </Button>
        </ModalBody>
      </Modal>
      <Modal size="sm" isOpen={modalSubirFotoBL} toggle={toggleSubirFotoBL}>
        <ModalHeader toggle={toggleSubirFotoBL}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosBL}>
            <i className="fas fa-save" /> Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalSubirFotoInvoice} toggle={toggleSubirFotoInvoice}>
        <ModalHeader toggle={toggleSubirFotoInvoice}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosInvoice}>
            <i className="fas fa-save" /> Guardar
          </Button>
        </ModalBody>
      </Modal>
      <Modal size="sm" isOpen={modalSubirFotoFichaTecnica} toggle={toggleSubirFotoFichaTecnica}>
        <ModalHeader toggle={toggleSubirFotoFichaTecnica}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosFichaTecnica}>
            <i className="fas fa-save" /> Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalSubirFotoCargosLocales} toggle={toggleSubirFotoCargosLocales}>
        <ModalHeader toggle={toggleSubirFotoCargosLocales}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosCargosLocales}>
            <i className="fas fa-save" /> Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalSubirFotoDODA} toggle={toggleSubirFotoDODA}>
        <ModalHeader toggle={toggleSubirFotoDODA}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosDODA}>
            <i className="fas fa-save" /> Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalSubirFotoBoleta} toggle={toggleSubirFotoBoleta}>
        <ModalHeader toggle={toggleSubirFotoBoleta}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosBoleta}>
            <i className="fas fa-save" /> Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalSubirFotoPrealta} toggle={toggleSubirFotoPrealta}>
        <ModalHeader toggle={toggleSubirFotoPrealta}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosPrealta}>
            <i className="fas fa-save" /> Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalSubirFotoBLRevalidado} toggle={toggleSubirFotoBLRevalidado}>
        <ModalHeader toggle={toggleSubirFotoBLRevalidado}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosBLRevalidado}>
            <i className="fas fa-save" /> Guardar
          </Button>
        </ModalBody>
      </Modal>

            <Modal size="sm" isOpen={modalSubirFotoEIR} toggle={toggleSubirFotoEIR}>
        <ModalHeader toggle={toggleSubirFotoEIR}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosDemorasCartas}>
            <i className="fas fa-save" /> Guardar
          </Button>
        </ModalBody>
      </Modal>

            <Modal size="sm" isOpen={modalSubirFotoDemorasCartas} toggle={toggleSubirFotoDemorasCartas}>
        <ModalHeader toggle={toggleSubirFotoDemorasCartas}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosDemorasCartas}>
            <i className="fas fa-save" /> Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalSubirFotoValidacion} toggle={toggleSubirFotoValidacion}>
        <ModalHeader toggle={toggleSubirFotoValidacion}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosValidacion}>
            <i className="fas fa-save" /> Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalSubirFotoGarantia} toggle={toggleSubirFotoGarantia}>
        <ModalHeader toggle={toggleSubirFotoGarantia}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosGarantia}>
            <i className="fas fa-save" /> Guardar
          </Button>
        </ModalBody>
      </Modal>
      <Modal size="sm" isOpen={modalSubirFotoTransporte} toggle={toggleSubirFotoTransporte}>
        <ModalHeader toggle={toggleSubirFotoTransporte}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosTransporte}>
            <i className="fas fa-save" /> Guardar
          </Button>
        </ModalBody>
      </Modal>

          <Modal size="xxl" isOpen={modalFotoInvoice} toggle={toggleFotoInvoice}>
      <ModalHeader toggle={toggleFotoInvoice}>
        <h4>Invoice</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  <i className="fas fa-download" /> Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    <i className="fas fa-download" /> Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                <i className="fas fa-trash-alt" /> Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

    <Modal size="xxl" isOpen={modalFotoFichaTecnica} toggle={toggleFotoFichaTecnica}>
      <ModalHeader toggle={toggleFotoFichaTecnica}>
        <h4>Ficha Tecnica</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  <i className="fas fa-download" /> Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    <i className="fas fa-download" /> Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                <i className="fas fa-trash-alt" /> Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

    <Modal size="xxl" isOpen={modalFotoCargosLocales} toggle={toggleFotoCargosLocales}>
      <ModalHeader toggle={toggleFotoCargosLocales}>
        <h4>Cargos Locales</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  <i className="fas fa-download" /> Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
               ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    <i className="fas fa-download" /> Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                <i className="fas fa-trash-alt" /> Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

    <Modal size="xxl" isOpen={modalFotoDODA} toggle={toggleFotoDODA}>
      <ModalHeader toggle={toggleFotoDODA}>
        <h4>DODA</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  <i className="fas fa-download" /> Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    <i className="fas fa-download" /> Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                <i className="fas fa-trash-alt" /> Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

    <Modal size="xxl" isOpen={modalFotoBoleta} toggle={toggleFotoBoleta}>
      <ModalHeader toggle={toggleFotoBoleta}>
        <h4>Boleta</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  <i className="fas fa-download" /> Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    <i className="fas fa-download" /> Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                <i className="fas fa-trash-alt" /> Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

    <Modal size="xxl" isOpen={modalFotoPrealta} toggle={toggleFotoPrealta}>
      <ModalHeader toggle={toggleFotoPrealta}>
        <h4>Prealta</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  <i className="fas fa-download" /> Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    <i className="fas fa-download" /> Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                <i className="fas fa-trash-alt" /> Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

    <Modal size="xxl" isOpen={modalFotoEIR} toggle={toggleFotoEIR}>
      <ModalHeader toggle={toggleFotoEIR}>
        <h4>EIR</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  <i className="fas fa-download" /> Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    <i className="fas fa-download" /> Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                <i className="fas fa-trash-alt" /> Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

        <Modal size="xxl" isOpen={modalFotoBLRevalidado} toggle={toggleFotoBLRevalidado}>
      <ModalHeader toggle={toggleFotoBLRevalidado}>
        <h4>BL Revalidado</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  <i className="fas fa-download" /> Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    <i className="fas fa-download" /> Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                <i className="fas fa-trash-alt" /> Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

        <Modal size="xxl" isOpen={modalFotoDemorasCartas} toggle={toggleFotoDemorasCartas}>
      <ModalHeader toggle={toggleFotoDemorasCartas}>
        <h4>Demoras y Cartas</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  <i className="fas fa-download" /> Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    <i className="fas fa-download" /> Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                <i className="fas fa-trash-alt" /> Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

    <Modal size="xxl" isOpen={modalFotoValidacion} toggle={toggleFotoValidacion}>
      <ModalHeader toggle={toggleFotoValidacion}>
        <h4>Validacion</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  <i className="fas fa-download" /> Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    <i className="fas fa-download" /> Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                <i className="fas fa-trash-alt" /> Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

    <Modal size="xxl" isOpen={modalFotoGarantia} toggle={toggleFotoGarantia}>
      <ModalHeader toggle={toggleFotoGarantia}>
        <h4>Garantia</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  <i className="fas fa-download" /> Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    <i className="fas fa-download" /> Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                <i className="fas fa-trash-alt" /> Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

    <Modal size="xxl" isOpen={modalFotoTransporte} toggle={toggleFotoTransporte}>
      <ModalHeader toggle={toggleFotoTransporte}>
        <h4>Transporte</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  <i className="fas fa-download" /> Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    <i className="fas fa-download" /> Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                <i className="fas fa-trash-alt" /> Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

      {loader}
    </>
  );
}

export default ListadoContenedores;
